export default {
  notification:{
    admin:{
      user:{
        add:{
          success:{
            a1:'Success',
            a2:'User Added Successfully'
          },
          error:{
            a1:'Failed',
            a2:'User Create Failed'
          }
        },
        confirm:{
          success:{
            c1:'confirm',
            c2:'Confirm Delete',
            c3:'You are about to delete {traineeName}',
            c4:'Delete'
          },
        },
        deleted:{
          success:{
            d1:'User Deleted',
            d2:'The selected user deleted successfully '
          },
          error:{
            d1:'User Deletion Failed',
            d2:'The selected user could not be deleted'
          },
          warning:{
            w1:'Confirm Delete',
            w2:'You are about to delete {username}'
          }
        },
        updateUser:{
          success:{
            u1:'Information Updated',
            u2:'Information was successfully updated'
          },
          error:{
            u1:'Information Update Failed',
            u2:'Information could not be updated'
          }
        },
        updateSocialDetails:{
          success:{
            u1:'Social Details Updated',
            u2:'Social details successfully updated'
          },
          error:{
            u1:'Social Details Update Failed',
            u2:'Social details could not be updated'
          }
        },
        cellRenderer:{
          coachAssign:{
            a1:'Coach Assigned',
            a2:'This Player is in a coaching relationship. If you want to remove the user; Delete the coaching assignment and try again.'
          },
          playerAssign:{
            p1:'Player Assigned',
            p2:'This User is in a coaching relationship. If you want to remove the user; Delete the coaching assignment and try again.'
          },
          confirmDelete:{
            c1:'Confirm Delete',
            c2:'You are about to delete {firstName}'
          }
        },
        update:{
          u1:'',
          u2:'',
          u3:''
        }
      },
      company:{
        add:{
          success:{
            a1:'Success',
            a2:'Company Added Successfully'
          },
          error:{
            a1:'Failed',
            a2:'Company Create Failed'
          }
        },
        updateCompany:{
          success:{
            u1:'Success',
            u2:'Company Updated Successfully'
          },
          error:{
            u1:'Failed',
            u2:'Company Not Updated Successfully'
          }
        },
        emailExist:{
          success:{
            e1:'Failed',
            e2:'Email Id already exists'
          },
        },
        deleted:{
          success:{
            d1:'User Deleted',
            d2:'The selected user deleted successfully '
          },
          error:{
            d1:'Failed',
            d2:'User Create Failed'
          }
        },
        confirmDelete:{
          confirm:{
            c1:'Coach Assigned',
            c2:'Player is associated with Organization. If you want to remove the Organization; Delete the users and try again.'
          },
          delete:{
            d1:'Confirm Delete',
            d2:'You are about to delete {name}'
          }
        },
        removeCompany:{
          success:{
            r1:'Company Deleted',
            r2:'The selected company was successfully deleted'
          },
          error:{
            r1:'Company Deletion Failed',
            r2:'The selected company could not be deleted, Because the User is associated with this company.'
          }
        },
        updateUser:{
          success:{
            u1:'Coach Updated',
            u2:'The selected coach was successfully updated'
          },
          error:{
            u1:'Coach Update Failed',
            u2:'The selected coach could not be updated'
          }
        },
        updateUserSocial:{
          success:{
            u1:'Coach Updated',
            u2:'The selected user was successfully updated'
          },
          error:{
            u1:'Coach Update Failed',
            u2:'The selected user could not be updated'
          }
        },
        update:{
          u1:'',
          u2:'',
          u3:''
        }
      },
      auth:{
        checkLogin:{
          warning:{
            w1:'Login Attempt',
            w2:'You are already logged in!'
          },
          error:{
            e1:'Error',
            e2:''
          }
        },
        update:{
          u1:'',
          u2:'',
          u3:''
        }
      },
      assignCoach:{
        coachAssigned:{
          success:{
            s1:'Success',
            s2:'Coach Assigned Successfully'
          },
          warning:{
            f1:'Failed',
            f2:'Self assignment is not possible'
          },
          failed:{
            f1:'Failed',
            f2:'Coach Already Assigned'
          }
        },
        deleted:{
          success:{
            d1:'User Deleted',
            d2:'The selected user was successfully deleted'
          }
        },
        updateAssigned:{
          success:{
            u1:'Success',
            u2:'Coach Assigned Updated Successfully'
          },
          failed:{
            u1:'Failed',
            u2:'Coach Assignment Update Failed'
          }
        },
        coachDeleted:{
          success:{
            d1:'Trainee Assigned Coach Deleted',
            d2:'The selected Trainee Assign Coach was successfully deleted'
          },
          failed:{
            d1:'Trainee Assign Coach Deletion Failed',
            d2:'The selected Trainee Assign Coach could not be deleted'
          }
        },
        showDeleteSuccess:{
          success:{
            d1:'Trainee Assign Coach Deleted',
            d2:'The selected Trainee Assign Coach was successfully deleted'
          }
        },
        updateUser:{
          success:{
            u1:'Coach Updated',
            u2:'The selected coach was successfully updated'
          },
          failed:{
            u1:'Coach Update Failed',
            u2:'The selected coach could not be updated'
          }
        },

        update:{
          u1:'',
          u2:'',
          u3:''
        }
      }
    },
    user:{
      addSkill:{
        userId:{
          success:{
            a1:'Coach switch to {traineeName} (Add Skill)'
          }
        },
        getCompetency:{
          a1:'{comp} attribute, has already been added'
        }
      },
      auth:{
        resetPassword:{
          success:{
            r1:'Password Changed',
            r2:'You have successfully Password Changed'
          },
          error:{
            r1:'Password Not Changed',
            r2:'You have Not successfully Password Changed'
          }
        },
        matchPassword:{
          notMatch:{
            n1:'Password are not match',
            n2:'Please Try Again'
          }
        },
        checkLogin:{
          warning:{
            w1:'Login Attempt',
            w2:'You are already logged in!'
          }
        },
        EmailExist:{
          error:{
            e1:'Error',
            e2:'Email Not Registered'
          },
          passwordReset:{
            r1:'Success',
            r2:'Password Reset Link Sent'
          }
        },
        signUp:{
          success:{
            s1:'Successful Registration',
            s2:'You have successfully registered'
          }
        }
      },
      components:{
        emailSent:{
          success:{
            e1:'Email Sent',
            e2:'Email Sent Successfully'
          }
        }
      },
      myCoach:{
        deleteUser:{
          confirm:{
            c1:'Confirm Delete',
            c2:'You are about to delete {username}'
          },
          success:{
            d1:'User Deleted',
            d2:'The selected user was successfully deleted'
          }
        },
        addNote:{
          success:{
            a1:'Success',
            a2:'Note Added Successfully'
          },
          failed:{
            a1:'Failed',
            a2:'Note Create Failed'
          }
        }
      },
      myRater:{
        raterList:{
          success:{
            a1:'Coach Switch to {traineeName} (Rater List)'
          }
        },
        mailCancel:{
          warning:{
            c1:'Email Canceled',
            c2:'Scheduled Email Already Cancel'
          },
          success:{
            c1:'Email Canceled',
            c2:'Scheduled Email Canceled Successfully'
          }
        },
        emailReschedule:{
          success:{
            s1:'Email Reschedule',
            s2:'Reschedule Email Successfully'
          },
          failed:{
            s1:'Email Reschedule',
            s2:'Reschedule Email Not Successfully'
          },
        }
      },
      profile:{
        confirm:{
          c1:'Confirm Delete',
          c2:'You are about to delete {username}'
        },
        profileSynced:{
          error:{
            e1:'User Profile',
            e2:'User data not synced'
          }
        },
        dataSynced:{
          success:{
            d1:'User Profile',
            d2:'User data sync successfully updated'
          },
          failed:{
            d1:'User Profile',
            d2:'User data not sync successfully updated'
          }
        },
        removeRecord:{
          success:{
            r1:'User Deleted',
            r2:'The selected user was successfully deleted'
          }
        }
      },
      skillDetails:{
        emails:{
          cancel:{
            success:{
              c1:'Email Canceled',
              c2:'Scheduled Email Canceled Successfully'
            },
            error:{
              c1:'Email Canceled',
              c2:'Scheduled Email Already Cancel'
            }

          },
          expire:{
            e1:'Email Expire',
            e2:'Email Expire Successfully'
          },
          sent:{
            e1:'Email Sent',
            e2:'Email Sent Successfully'
          },
          schedule:{
            success:{
              c1:'Email Reschedule',
              c2:'Reschedule Email Successfully'
            },
            error:{
              c1:'Email Reschedule',
              c2:'Reschedule Email Not Successfully'
            }

          }

        },
        rater:{
          deactivate:{
            success:{
              a1:'Success',
              a2:'Rater deactivated Successfully'
            },
            error:{
              a1:'Failed',
              a2:'Rater Deactivation Failed'
            }
          },
          activate:{
            success:{
              a1:'Success',
              a2:'Rater activated Successfully'
            },
            error:{
              a1:'Failed',
              a2:'Rater Activation Failed'
            }
          }
        },
        invite:{
          emailFind:{
            e1:'Rater Email Exists',
            e2:'Rater Email already exist , Please Invite another Rater Email'
          },
          userFind:{
            u1:'Rater Email Exists',
            u2:'Player can not invite for peer Feedback itself, Please Invite another Rater Email'
          }
        }
      },
      todo:{
        update:{
          success:{
            u1:'Success',
            u2:'Status Updated Successfully'
          },
          failed:{
            u1:'Failed',
            u2:'Status Updation Failed'
          }
        }
      },
      traineeList:{
        removeRecord:{
          success:{
            r1:'User Deleted',
            r2:'The selected user was successfully deleted'
          },
          failed:{
            r1:'User Deletion Failed',
            r2:'The selected user could not be deleted'
          }
        },
        updateUser:{
          success:{
            u1:'Information Updated',
            u2:'Information was successfully updated'
          },
          failed:{
            u1:'Information Update Failed',
            u2:'Information could not be updated'
          }
        },
        updateSocial:{
          success:{
            u1:'Social Details Updated',
            u2:'Social details successfully updated'
          },
          failed:{
            u1:'Social Details Update Failed',
            u2:'Social details could not be updated'
          }
        },
        rater:{
          r1:'Mentor Switch to Player(Rater List)'
        },
        emailSchedule:{
          cancelSchedule:{
            warning:{
              c1:'Email Canceled',
              c2:'Scheduled Email Already Cancel'
            },
            success:{
              c1:'Email Canceled',
              c2:'Scheduled Email Canceled Successfully'
            }
          },
          reSchedule:{
            success:{
              s1:'Email Reschedule',
              s2:'Reschedule Email Successfully'
            },
            failed:{
              s1:'Email Reschedule',
              s2:'Reschedule Email Failed'
            }
          }

        },
        addUser:{
          success:{
            a1:'Success',
            a2:'User Added Successfully'
          },
          failed:{
            a1:'Failed',
            a2:'User Create Failed'
          }
        }
      }
    }
  },
  trainingLibrary:{
    presentations:"Presentations",
    video:'Video tutorials',
    books:"Books",
    contact:'Contact support',
    appsIntegration:'Apps and Integrations',
    ogrNot:'Training center is not yet activated for your organization',
    gbSupport:'Contact GetBoarded Support.'
  },
  coachLogin:{
    trainee:{
      raterList:'Advisors details of ',
      addSkill:'You are viewing this page information as '
    },
  },
  login: {
    title: "Login",
    h1: "Welcome back, please login to your account.",
    tb1: "Email Login",
    tb2: "Single Sign On",
    lbl1: "Email",
    lbl2: "Password",
    lbl3: "Remember Me",
    lbl4: "Forgot Password",
    btn1: "Login",
    btn2: "Login with PeopleTree",
    btn3: "Login with GetBoarded"
  },
  home_title: "Progress Dashboard",
  Response: {
    t1: 'NO GAP',
    t2: 'SMALL GAP',
    t3: 'MODERATE GAP',
    t4: 'LARGE GAP',
    t5: 'SIGNIFICANT GAP'
  },
  playerJourney: {
    t1_1: 'Player has created account',
    t1_2: 'Player has not created account',
    t2_1: 'Skills Added  ',
    t2_2: 'Has not Started adding skills',
    t3_1: 'Motivation Survey Complete',
    t3_2: 'Motivation Survey Overdue',
    t3_3: 'Yet to complete first motivation Survey',
    t4_1: 'Coaching Survey Complete',
    t4_2: 'Coaching Survey Overdue',
    t4_3: 'Yet to complete first Coaching Survey'
  },
  RequestAccess: "Request Access",
  routeTitle: {
    t1: "Player Details",
    t2: "Development Experience"
  },
  CoachProfile:"My Coach Profile",
  CoacheeList:"Player List",
  coachingExperiences:"Experience Log",
  Addnewskill:"Set a Goal",
  MySkills:"My Abilities ",
  MyProfile:"My Profile",
  MyMentorProfile: "My Coach Profile",
  MyRaters:"My Advisors",
  MyDevelopmentManager:"My DPM",
  Progress_measure:"Your Progress Measure",
  Progress:"Progress",
  progressStatus:"In Progress",
  progressStatus1:"Goal Completed",
  Account:"Account",
  Information:"Information",
  TrainingCenter:"Training Center",
  Videos:"Videos",
  Books:"Books",

  PersonalInformation:"Personal Information",
  Male:"Male",
  Female:"Female",
  Other:"Other",
  Address:"Address",
  PostCode:"Post Code",
  socialLink: "Social Links",
  Coachee: "Player",
  Coach: "Coach",
  calender:{
    c1:" started working on ",
    c2:" Goal on ",
    c3:" marked completed by ",
    c4:" has not added any Abilities ."
  },
  Invited:"Invited",
  GapClosed:"Gap Closed",
  Benchmark:"Feedback Received",
  Benchmark_1:"Benchmark",
  GapBigger:"Gap Bigger",
  NoRating:"No Rating",
  GapSmaller:"Gap Smaller",
  LogOut:"Log Out",

  Attribute_History: "Attribute History",
  TrainingDuration: "Select Custom Duration",
  User: "Founders",
  Company: "Organization",
  AssignCoach: "Coach Assignments",
  TraineeDetails: "Player Details",
  Trainee: "Player",
  raterDetails: "Advisor Details",
  Rater: "Advisor",
  Access: "Access",
  List: "List",
  Edit: "Edit",
  userlist: "Founder List",
  edituser: "User Edit",
  adduser: {
    title: "Founder",
    lbl0: "User Type",
    lbl1: "First Name",
    lbl2: "Last Name",
    lbl3: "Email",
    lbl4: "Organization",
    lbl5: "Language",
    btn0: "Submit and Send Invite"
  },
  companylist: "Organization List",
  addcompany: {
    title: "Add Organization",
    lbl0: "Organization Name",
    lbl1: "Admin Email",
    lbl2: "Password",
    lbl3: "Coaching Survey",
    lbl4: "Motivation Survey",
    lbl5: "Terminology",
    lbl5_opt0: "Coach",
    lbl5_opt1: "DPM",
    lbl6: "Enterprise",
    lbl6_opt0: "Free",
    lbl6_opt1: "Paid",
    lbl7: "Theme Color",
    lbl8: "Feedback Frequency",
    lbl9: "Secondary Color"
  },
  updatecompany: {
    title: "Update Organization",
    lbl2: "New Password",
    lbl3: "Confirm Password"
  },
  Save: "Save",
  Submit: "Submit",
  Update: "Update",
  Cancel: "Cancel",
  Schedule: "Schedule",
  Extend: "Extend",
  requestAccess: {
    title: "Request Access",
    popupTitle: "Upgrade Plan",
    popupText1: "To add unlimited users, upgrade to an enterprise access to Coach App.",
    popupText2: "To add a single user",
    h1: "My Coach",
    p1: "Request an access",
    q1: "What is your full name? This question is required. *",
    q2: "Your email?",
    q3: "Do you have any coupon code?",
    q3p: "Enter your code, if you have any, else skip to payment."
  },
  home: {
    h1: "Welcome",
    h2: "You haven't added any skills",
    h3: "When you add skills, they will appear below",
    h4: "Add New Skill",
    h5: "Time to view your progress",
    h6: "Your Latest Stats",
    h7: "Skill Details",
    h8: "Your Previous Stats"
  },
  coachingExperience: {
    ce1: "No Coaching association Found! Please contact admin to map your coach.",
    ce2: "Your development experience survey is currently overdue for more than ",
    ce3: "Going Great",
    ce4: "Can be Better",
    ce5: "Your feedback has been submitted successfully!",
    ce6: "We are glad things are going well!",
    ce7: "Your next checkpoint for coaching survey will be in ",
    ce8: "Provide feedback on your development experience with this coaching. It will help us understand your development journey",
    ce9: "Personal Experience",
    ce10: "How happy are you with your development experience? Think; Can I be myself? Do I dare to ask and show I do not know? Or do I have to wear a mask and act like someone I am not?",
    ce11: "Resource Availability",
    ce12: "Do you have sufficient time and resources available to you to achieve your goals? Think; Can I develop myself? Can I evolve ?",
    ce13: "Leadership Support",
    ce14: "Are you getting the support you need from your organizational leadership? Think; Am I safe here? Do I contribute to the bigger Organizational goal? Is my contribution recognized? Valorised?",
    ce15: "Submit",
    ce16: "Your feedback has been submitted successfully!",
    ce17: "We will work to improve your experience in the future. Keep up the good work.",
    ce18: "Your next checkpoint will be in a month. But feel free to submit feedback anytime!",
    ce19: " Days.",
    ce20: " \n" +
        "Please take a minute to suggest if your skill development is on track.",
    ce21: "Frequency of reminders is set by Organization, but feel free to submit feedback anytime you want!",
    ce22: "Need to start adding skills before a coaching experience can be logged",
    ce23: "Development experience survey is recently completed. You will be able to submit a new one soon."
  },

  addNewSkill: {
    ans1: "Back",
    ans2: "Next",
    ans3: "Submit",
    data: {
      'ed': {
        characteristic: 'Individual Performance Template',
        wdd: "Evaluate performance of an Individual on consistently achieving results and meeting goals and targets; being motivated to achieve career advancement; sticking to a course of action despite obstacles and seeing things through to the end; taking initiative and demonstrate a positive can-do attitude.",
        icon: require('@/assets/Iconography/Characteristics/07_Energetic Driver.svg'),
        competencies: [
          {
            id: 'ed-0',
            icon: require('@/assets/Iconography/Attributes/07-01_Achieving Goals.svg'),
            comp: 'Delivering high levels of customer service',
            wdd: 'Delivering a high level of customer service requires people to build and manage relationships with customers, always keeping the customers needs in mind. This requires a willingness to actively engage with people as well as using diplomacy to manage any potential conflict. People who excel at customer service are great listeners and make the customer feel that they are working for them.',
            progressMeasures: [
              {
                id: 'ed-0-0',
                pm: 'Acheiving goals and performance targets for myself',
                pmMap: 'Achieve the goals and performance targets for myself'
              },
              {
                id: 'ed-0-1',
                pm: 'Setting a high standard for self',
                pmMap: 'Strive to do well and set a high standard for myself'
              },
              {
                id: 'ed-0-2',
                pm: 'Keep high energy and not get drained by obstacles',
                pmMap: 'Not let my energy get drained by obstacles'
              },
              {
                id: 'ed-0-3',
                pm: 'Learning to step back and recharge before tackling tasks that appear insurmountable',
                pmMap: 'Know how to step back and recharge before tackling tasks that appear insurmountable'
              }
            ],
            developmentActions: [
              {
                id: 'ed-0:1-a',
                da: 'As a rule, first do the things you do not want to do. You will have to do them anyway, and often they prevent you from working productively because you spend too much energy trying to avoid these few tasks. Write down what they are and enlist a co-worker to keep you on track.'
              },
              {
                id: 'ed-0:1-b',
                da: 'Focus on doing the things that matter most so that you spend your time wisely. If time overtakes you, you will at least have taken care of the items that have the most impact. Be specific about what these things are and create a priority list. Confirm with an appropriate person that you have prioritized accurately.'
              },
              {
                id: 'ed-0:1-c',
                da: 'Tackle the task in palatable increments. Work on things during breaks you may have between your commitments and appointments. It will ensure the amount of work is manageable and you will see increasing progress.'
              },
              {
                id: 'ed-0:1-d',
                da: 'Anticipate that everything will take longer to complete than you expected. Whatever the deadline, subtract time from it to give yourself impetus to start. Reward yourself every time you meet the deadline.'
              },
              {
                id: 'ed-0:1-e',
                da: 'Take action immediately. Limit the time between getting the assignment and starting to work. Sitting still too long without taking action can harm your motivation.'
              },
              {
                id: 'ed-0:1-f',
                da: 'If you perform best or are motivated by working with others, recruit peers with whom you can collaborate to get you started. They will also be able to help keep you on track, especially if your performance is tied to others.'
              },
              {
                id: 'ed-0:2-a',
                da: 'Limit the time you spend on a given assignment. Set points at which you will confer with your superior for feedback on the level of detail you should be achieving. This will help to keep your expectations of yourself realistic.'
              },
              {
                id: 'ed-0:2-b',
                da: 'Reframe your expectations. Aim for completing a task or assignment well, not making it perfect.'
              },
              {
                id: 'ed-0:3-a',
                da: 'Build flexibility into your schedule so that you can tackle a particular project at a time that makes sense for you. Many people mark specific time blocks off to work on an assignment, but if you are burnt out this may backfire because your inspiration and motivation will be inconsistent ” they cannot be scheduled. Take advantage of the times you feel ready to work on a project, even if it is just for a short period. Conversely, move on to something else if you are not producing anything. Spinning your wheels will build frustration and increase negative associations with the work at hand.'
              },
              {
                id: 'ed-0:3-b',
                da: 'Review and reward your progress continually. Break down the project into smaller tasks and reward yourself every time you accomplish a step.'
              },
              {
                id: 'ed-0:3-c',
                da: 'Be honest with your superior. They may be able to assist you by doing something simple such as helping you to delegate some of your work. Often, people do not like to inform their superior of problems because they do not want to appear as if they cannot handle the situation. Inevitably, though, burnout will show in your performance, so act before it does.'
              },
              {
                id: 'ed-0:3-d',
                da: 'Shake things up ” if you are chronically feeling burnt out it may be time to look for another position within the company or try something completely new. Spend time to investigate your options and set your goal.'
              },
              {
                id: 'ed-0:4-a',
                da: 'Focus on doing the things that matter most. Be specific about what they are and create a priority list. Confirm with your superior that you have prioritized well and accurately. require you to extend yourself.'
              },
              {
                id: 'ed-0:4-b',
                da: 'Which activities take up most of your time? Create a list of your activities and assign the approximate times you are spending on each category. Then divide the categories into essential and â€œneed to do. What does your time allotment look like? mistake, write a list of the benefits of having made the mistake â€” the specifics of what you have learned, who you met in the process and so forth.'
              },
              {
                id: 'ed-0:4-c',
                da: 'Are you delegating appropriately? In which tasks can you involve others? theme of risk taking among them.'
              },
              {
                id: 'ed-0:5-a',
                da: 'Slowly raise your risk comfort level by taking on smaller assignments that require you to extend yourself.'
              },
              {
                id: 'ed-0:5-b',
                da: 'View mistakes as opportunities to learn and reflect. Every time you make a mistake, write a list of the benefits of having made the mistake â€” the specifics of what you have learned, who you met in the process and so forth.'
              },
              {
                id: 'ed-0:5-c',
                da: 'Read biographies of business or public leaders who you admire. Look for a common theme of risk taking among them.'
              },
              {
                id: 'ed-0:5-d',
                da: 'You may have taken more risk than you have thought or given yourself credit for. Document your accomplishments. What risks did each of these accomplishments involve? Write them down, regardless how small the risk was. Ask people who know you well to help you. The objective is to show that all careers are based on a combination of challenges to which we are continuously called upon to rise. You may already be more of a risk taker than you think.'
              },
              {
                id: 'ed-0:6-a',
                da: 'If you do not have a work plan yet, meet with your superior to develop one with specific goals and targets for each year. Agree to reassess your work plan occasionally to make any changes necessary.'
              },
              {
                id: 'ed-0:6-b',
                da: 'Be prepared to ask your supervisor and peers about your performance and whether you are meeting their expectations.'
              },
              {
                id: 'ed-0:6-c',
                da: 'Take a cue from peers that are known high performers. Compare your standard of work to theirs â€” do not rely on your own perception. Use their assessment as a yardstick to measure your level of accomplishment.'
              }
            ]
          },
          {
            id: 'ed-1',
            icon: require('@/assets/Iconography/Attributes/07-02_Advancing My Career.svg'),
            comp: 'Working well with others',
            wdd: 'People who are approachable, collaborative and care about relationships are much easier to work with than those who dont. Almost all jobs require the help and co-operation of other people in order to be successful.',
            progressMeasures: [
              {
                id: 'ed-1-0',
                pm: 'I usually feel confident that I can succeed in any role or position I choose to do',
                pmMap: 'Feel confident that I can succeed in any role or position I choose to do'
              },
              {
                id: 'ed-1-1',
                pm: 'I am clear about what I need to do to advance my career',
                pmMap: 'Be clear about what I need to do to advance my career'
              },
              {
                id: 'ed-1-2',
                pm: 'I am taking the necessary action to work towards career advancement',
                pmMap: 'Take the necessary action to work towards career advancement'
              },
              {
                id: 'ed-1-3',
                pm: 'I discuss my future plans with my people who can help me achieve them',
                pmMap: 'Discuss my future plans with my people who can help me achieve them'
              }
            ],
            developmentActions: [
              {
                id: 'ed-1:1-a',
                da: ' Every day, visualize the things you want in your life and career. A growing movement believes in the power of visualization to attract what we need in our lives. Read The Secret by Rhonda Byrne.'
              },
              {
                id: 'ed-1:1-b',
                da: ' Positive affirmation can help to rewire your thinking. Be vigilant against negative thoughts about yourself and practice to replace them with positive ones immediately.'
              },
              {
                id: 'ed-1:1-c',
                da: ' Identify a few people who you admire for their self-confidence and talk to them about their views on the world. Note the differences in your thinking styles.'
              },
              {
                id: 'ed-1:1-d',
                da: ' Do not give mistakes more importance than they deserve. Write down the worst-case scenarios and analyze them. Unless your life or someone else\'s is at stake, the worst is never as bad as you might think.'
              },
              {
                id: 'ed-1:1-e',
                da: ' Read about people who have made mistakes but still succeeded, such as Thomas Edison. It took 10 000 failures to make the light bulb!'
              },
              {
                id: 'ed-1:1-f',
                da: ' You do not need to have all the answers. Work the part of your plan that you can, and ask for help with the rest.'
              },
              {
                id: 'ed-1:1-g',
                da: ' Extend your comfort zone. You are building confidence every time you take on a new challenge or task. Keep score of the new challenges you have overcome.'
              },
              {
                id: 'ed-1:1-h',
                da: ' Understand what your challenges will be if you were to move to a new position or role. List the things you are potentially uncomfortable doing. It could be managing people for the first time, networking more than usual or learning more about a specific technical area. Be as detailed as possible with your list. Which items on the list are perceived challenges and which ones are real? For example, you may not have supervised people before but work well with others, are approachable, patient, manage conflict well etcetera. All these behaviors point to your likely success as a leader.'
              },
              {
                id: 'ed-1:1-i',
                da: ' Learn more about the position you are interested in by spending time with the incumbent or someone in a similar role. Find out what they regard as the greatest challenges of the position. The more you know the better equipped you will be to start the job without being blindsided by unexpected demands.'
              },
              {
                id: 'ed-1:1-j',
                da: ' If you believe you truly lack the skills critical to getting a promotion, talk to your supervisor about devising a development plan that involves key assignments and experiences to help build your skills set. Make sure you communicate both your interest and your concern about shortcomings.'
              },
              {
                id: 'ed-1:1-k',
                da: ' In the end, no amount of preparation will guarantee you are 100% ready for a position. If the opportunity is available and you want to do it, stop thinking and take action.'
              },
              {
                id: 'ed-1:1-l',
                da: ' If you find that your lack of self-confidence is affecting your ability to function and advance in your career, seek the help of a professional coach or counselor as part of your development plan. A trained therapist can help you to challenge deep-rooted thinking patterns.'
              },
              {
                id: 'ed-1:2-a',
                da: ' Revisit your career goals. Are you still on track? Is your lack of motivation due to your current assignment or another temporary circumstance, or is the problem your position itself?'
              },
              {
                id: 'ed-1:2-b',
                da: ' Identify the specific needs that are not being met by your position. Assessment tools such as the Birkman method scrutinizes individuals\' less obvious needs that are not met in their work environment and professional relationships. Other factors may be more obvious, such as salary, your relationship with your boss or a lack of challenging assignments. The app has a motivation survey which addresses motivational areas.'
              },
              {
                id: 'ed-1:2-c',
                da: ' Talk to your supervisor about the role you envision for yourself and how the opportunity can be created. Be honest - your supervisor may be thinking you are perfectly content with your situation.'
              },
              {
                id: 'ed-1:2-d',
                da: ' It is important to keep the momentum going when you are unmotivated. Identify three actions to complete in the next month that could help you to regain interest in your career.'
              },
              {
                id: 'ed-1:2-e',
                da: ' Try to visualize yourself doing something new. What would be your dream position in the organization? It makes sense to create a vision of your future then focus strategically on how to get there.'
              },
              {
                id: 'ed-1:2-f',
                da: ' Continue to look for opportunities within the company by networking and trying new roles until you find a project, assignment or job that motivates you.'
              },
              {
                id: 'ed-1:3-a',
                da: ' Put a plan in place for your career advancement. Let your supervisor help to identify the competencies, experience and technical skills you will need to get promoted.'
              },
              {id: 'ed-1:3-b', da: ' Take the initiative to find out about positions open in your company.'},
              {
                id: 'ed-1:3-c',
                da: ' Become knowledgeable about the skills considered scarce in your industry. Companies make extra efforts to retain employees with these skills.'
              },
              {
                id: 'ed-1:3-d',
                da: ' Try to visualize yourself doing something new. What would your dream opportunity in the organization be? It makes sense to create a vision of your future then focus strategically on how to get there.'
              },
              {
                id: 'ed-1:3-e',
                da: ' Make time to network. Talking to people and getting more exposure increase your chances of discovering new ways to raise your visibility and advance your career.'
              },
              {
                id: 'ed-1:3-f',
                da: ' Take growth one small step at a time if you are not comfortable with drastic changes or do not really know which step to take next. Experiment with new assignments that test different skills. It may surprise you to discover other things at which you are really talented. You will find yourself getting more comfortable doing different assignments the more diverse your experiences become.'
              },
              {
                id: 'ed-1:3-g',
                da: ' Inquire about short-term opportunities in your company, perhaps in a new department, if this could help you to advance towards your long-term goals.'
              },
              {
                id: 'ed-1:3-h',
                da: ' Read The Leadership Pipeline by Ram Charan and Stephen Drotter, which describes the competencies necessary to function successfully throughout different organizational levels.'
              },
              {
                id: 'ed-1:4-a',
                da: ' Can you pinpoint the reasons why you are feeling so burnt out? Which things within your control can change and which cannot? You will be surprised to see how changing one or two factors can provide the room you need to re-energize. Get feedback from family, peers or a coach about what those factors could be. Sometimes we find it hard to see what seem obvious to those around us.'
              },
              {
                id: 'ed-1:4-b',
                da: ' Is your workload reasonable and realistic? Talk to the relevant people about your work distribution if that contributes greatly to your burnout.'
              },
              {
                id: 'ed-1:4-c',
                da: ' Make sure you recharge daily with exercise or a hobby that helps to take your mind off work.'
              },
              {
                id: 'ed-1:4-d',
                da: ' Which aspects of the opportunity being offered do you like and which ones put you off? Which terms are negotiable? Typically, there are ways to tailor a promotion to better fit your needs.'
              },
              {
                id: 'ed-1:4-e',
                da: ' Observe successful people in your organization who have demanding jobs but keep a balance between their professional and private lives. Learn how they do it.'
              },
              {
                id: 'ed-1:4-f',
                da: ' Take a breather before making a decision. Take some time off to relax and think clearly. Whatever your decision upon your return, it will be based on a better perspective.'
              },
              {id: 'ed-1:5-a', da: ' Write down the pros and cons of staying in the same position.'},
              {
                id: 'ed-1:5-b',
                da: ' Identify a position that truly piques your interest and for which you would be willing to make sacrifices. Keep searching if you cannot identify something now.'
              },
              {
                id: 'ed-1:5-c',
                da: ' Even if you are not ready for a promotion, keep discussing possibilities with your peers and supervisor to demonstrate your interest.'
              },
              {
                id: 'ed-1:5-d',
                da: ' Talk to people in other positions a level or two above yours. Ask how they like their jobs and what the principal benefits are.'
              },
              {
                id: 'ed-1:5-e',
                da: ' Find out as much as possible about the position under consideration. It is common to make incorrect assumptions about the responsibilities a position entails. Talk to the incumbent, if possible, or others who have been in a similar role.'
              },
              {
                id: 'ed-1:5-f',
                da: ' Engage a coach to examine in depth the reasons why you are not interested in taking on more responsibility.'
              },
              {
                id: 'ed-1:6-a',
                da: ' Approach your self-promotion like you would any other business endeavor and create a personal marketing plan. Establish the actions you will undertake and hold yourself accountable weekly.'
              },
              {id: 'ed-1:6-b', da: ' Create a weekly status report to inform your boss about your accomplishments.'},
              {
                id: 'ed-1:6-c',
                da: ' Communicate your efforts to all your stakeholders, not just your peers or manager. If appropriate, consider informing your clients, senior management and business network.'
              },
              {
                id: 'ed-1:6-d',
                da: ' Learn to create a brief statement that communicates the highlights of your success without providing unnecessary details.'
              },
              {
                id: 'ed-1:6-e',
                da: ' Be wary of being too modest. Are you deflecting praise too quickly? Accept welldeserved praise graciously and with pride.'
              },
              {
                id: 'ed-1:6-f',
                da: ' Do not accept blame too quickly. You are accountable for your actions, not other people\'s mistakes. Taking blame when it is undeserved dilutes perceptions of your contribution.'
              },
              {
                id: 'ed-1:6-g',
                da: ' You may be more comfortable promoting your group\'s effort, which gives you a chance to highlight your role but share the accolades.'
              },
              {
                id: 'ed-1:6-h',
                da: ' Prepare well for your performance reviews. You must be able to highlight accomplishments and provide supporting documentation for the less obvious goals you have met.'
              },
            ]
          },
          {
            id: 'ed-2',
            icon: require('@/assets/Iconography/Attributes/07-03_Being Determined.svg'),
            comp: 'Personal motivation and drive',
            wdd: 'High levels of personal motivation and drive increase the discretionary effort that a person is willing to make. High performance requires high levels of person energy, and if this drive is not there, it is difficult to achieve performance targets.',
            progressMeasures: [
              {
                id: 'ed-2-0',
                pm: 'I rarely quit before I have completed a task or project',
                pmMap: 'Rarely quit before I have completed a task or project'
              },
              {
                id: 'ed-2-1',
                pm: 'I recover quickly from emotional setbacks during a project',
                pmMap: 'Recover quickly from emotional setbacks during a project'
              },
              {
                id: 'ed-2-2',
                pm: 'I have completed long-term projects successfully',
                pmMap: 'Completing long-term projects successfully'
              },
              {
                id: 'ed-2-3',
                pm: 'I do not like leaving anything incomplete',
                pmMap: 'Not leave things incomplete'
              }
            ],
            developmentActions: [
              {
                id: 'ed-2:1-a',
                da: ' Ensure that new initiatives are introduced in a manner that creates buy-in from all stakeholders and that the infrastructure and resources exist to facilitate the appropriate follow-through.'
              },
              {
                id: 'ed-2:1-b',
                da: ' Celebrate small goals or milestones along the way. It may take a while to realize the project completely, and acknowledging the steps needed to get there will keep you motivated.'
              },
              {
                id: 'ed-2:1-c',
                da: ' Make progress, not inspiration, your primary goal. It means you must focus on the steps necessary to mature an existing product or service instead of trying to generate new ones. Make a detailed plan of the steps necessary to translate the idea into practice. Once you have identified these steps in your plan, you can apply the same framework for future ideas.'
              },
              {
                id: 'ed-2:1-d',
                da: ' Be sure to monitor your work processes. Once distracted by new initiatives, it is easy to abandon the monitoring of existing projects\' progress. Why compromise the hard work and resources that have been invested because of a lack of oversight?'
              },
              {
                id: 'ed-2:1-e',
                da: ' Find a trusted peer that can cheer you on when you are struggling. An external perspective to remind you how close you are to your goal, or simply someone to listen to your feelings can be just the life vest you need when you are least inspired.'
              },
              {
                id: 'ed-2:1-f',
                da: ' Have you lost sight of your vision? Occasionally, reflect on the bigger picture and what it was that excited you about the work in the first place.'
              },
              {
                id: 'ed-2:1-g',
                da: ' First complete the things you least like doing and get them out of the way while your motivation is highest. It will be easier to tackle the less complex tasks when you have less energy.'
              },
              {
                id: 'ed-2:1-h',
                da: ' If you simply cannot get excited about working on a particular assignment or task, you may need some time to recharge by focusing on something else. Taking a break from the task at hand will give you a chance to recharge. Can you ask for assistance?'
              },
              {
                id: 'ed-2:1-i',
                da: ' If you are not a detail-oriented person, you are likely to lose interest quickly and prefer to move on to something new. Make sure there are people on your team who are more analytical or concerned with detail and can drive that aspect of the project.'
              },
              {
                id: 'ed-2:1-j',
                da: ' Certainly, some aspects of everyone\'s jobs are less interesting than others, but if nothing holds your interest or you are chronically bored, you should consider whether your position is right for you.'
              },
              {
                id: 'ed-2:2-a',
                da: ' Keep things as simple as possible by narrowing your focus to one or two core drivers of the problem. Articulate what those drivers are.'
              },
              {
                id: 'ed-2:2-b',
                da: ' Focus on the starting point and not the finishing line. What is most important as a first course of action? List all the possibilities and choose only a few avenues on which to focus for now. There is never a perfect place from which to start. Once you have accomplished the initial steps, begin again.'
              },
              {
                id: 'ed-2:2-c',
                da: ' Assemble a strong team that has multiple skills and can tackle all the various angles of the project. You do not have to be an expert in every aspect.'
              },
              {
                id: 'ed-2:2-d',
                da: ' Do not linger on a problem too long before addressing it. The longer you leave an issue unaddressed the more overwhelming it becomes.'
              },
              {
                id: 'ed-2:3-a',
                da: ' Often, once you gain a better perspective or have more information, obstacles are not as difficult to overcome as they first appeared. Ask a trusted colleague or expert to provide a different perspective. Someone else might be able to see an obvious solution that you cannot just then.'
              },
              {
                id: 'ed-2:3-b',
                da: ' Use obstacles as opportunities to have fun while being creative. There are always multiple ways to approach an issue. Do you need to start over again or simply change your course of action? Many plans have failed not because they were not good, but because they were inflexible.'
              },
              {
                id: 'ed-2:3-c',
                da: ' Your biggest obstacle may be your emotions or attitude. Examine the real reasons why you are contemplating giving up and make sure the reasons are based on logic, not emotion.'
              },
              {
                id: 'ed-2:3-d',
                da: ' Reflect on your original purpose for embarking on this route and become motivated again. Sometimes a shot of energy is all you need to get you over the hurdle.'
              },
              {
                id: 'ed-2:4-a',
                da: ' Always add to your timelines to allow for contingencies. You want to start with a realistic timeframe for completion and mitigate unnecessary frustration.'
              },
              {
                id: 'ed-2:4-b',
                da: ' Do you have other things on your plate? There is no reason not to move on to another project if you are simply not able to focus on a specific task at the moment, but be sure to return at a later stage to address what you had left behind.'
              },
              {
                id: 'ed-2:4-c',
                da: ' Rather than give up altogether because things are not moving fast enough, find ways to improve the process so that it can be completed more quickly. This might involve recruiting additional resources to help.'
              },
              {
                id: 'ed-2:4-d',
                da: ' Does the whole task have to be done from beginning to end at once? Divide it into smaller tasks on which you can work progressively.'
              }
            ]
          },
          {
            id: 'ed-3',
            icon: require('@/assets/Iconography/Attributes/07-04_Taking Initiative.svg'),
            comp: 'Producing high quality work/output',
            wdd: 'To produce high quality work you need to pay attention to the detail, reduce the number of errors in the work you do and meet prescribed quality standards. This means constantly learning from experience and becoming more competent at your job.',
            progressMeasures: [
              {
                id: 'ed-3-0',
                pm: 'I am excited about my work',
                pmMap: 'Demonstrate excitement about my work'
              },
              {
                id: 'ed-3-1',
                pm: 'If I see things that must be done, I am proactive and get involved',
                pmMap: 'See things that must be done, and proactively get involved'
              },
              {
                id: 'ed-3-2',
                pm: 'I do not wait to be told what work to do',
                pmMap: 'Not wait to be told what work to do'
              },
              {
                id: 'ed-3-3',
                pm: 'I take initiative even if the decision is risky',
                pmMap: 'Take initiative even if the decision is risky'
              }
            ],
            developmentActions: [
              {
                id: 'ed-3:1-a',
                da: ' Are you assuming you lack the necessary skills before you really know what an assignment entails? If you lack confidence in your skills, you are likely to make quick judgments not necessarily based on facts. Talk to relevant people about what is really needed. Ensure your expectations of yourself compare with those your superior has of you. If you are usually hard on yourself, you are probably overestimating what you need to know to get going.'
              },
              {
                id: 'ed-3:1-b',
                da: ' If your skills set is insufficient for the task at hand, take initiative by recruiting someone else to work with you. You can learn from this person and contribute your strengths at the same time. Use a suitable, knowledgeable peer as a sounding board for ideas.'
              },
              {
                id: 'ed-3:1-c',
                da: ' Volunteer to do assignments that will challenge and extend your abilities. List the things you are least comfortable doing. Resolve to do at least one task or assignment every month that will help you to develop a weak area.'
              },
              {
                id: 'ed-3:1-d',
                da: ' Formulate an individual development plan with your supervisor or coach to address areas in which you particularly lack confidence. Why wait to address a weakness when you can have an ongoing development strategy designed to improve it?'
              },
              {
                id: 'ed-3:1-e',
                da: ' Remind yourself of other times when you were apprehensive about tackling a challenge. What was the result? Did your level of skill derail the project?'
              },
              {
                id: 'ed-3:1-f',
                da: ' If you do not know where to begin, take the initiative by being resourceful. Find out who can help with particular tasks; investigate the work that was done in similar projects and the reference material available to get you up to speed. Instead of spinning your wheels anxiously, start asking the right questions.'
              },
              {
                id: 'ed-3:2-a',
                da: ' Weigh the likelihood of the situation or decision\'s complete failure, and the degree of damage should the worst-case scenario materialize. Reality tends to be less severe than perception. Talk to a trusted peer or mentor who can be a sounding board for your concerns. They can help to provide perspective. Do they think the situation is as risky as you do?'
              },
              {
                id: 'ed-3:2-b',
                da: ' Become comfortable making decisions without complete data. Practice trusting your intuition. In his book Blink, Malcom Gladwell champions the power of using intuition in decision making. Start with small decisions and progress to ones with bigger consequences.'
              },
              {
                id: 'ed-3:2-c',
                da: ' Get used to making decisions regardless of conventional wisdom or the level of support they enjoy. Taking initiative will sometimes mean paving a new way all on your own.'
              },
              {
                id: 'ed-3:2-d',
                da: ' Pair with someone who is more risk-tolerant and can help you to take initiative in projects beyond your comfort zone.'
              },
              {
                id: 'ed-3:2-e',
                da: ' Identify beforehand the risks associated with your work, business, project etcetera. Having a plan to manage risk, should it become an issue, will give you a greater sense of control.'
              },
              {
                id: 'ed-3:2-f',
                da: ' Do reflection after projects, on your own and with your team. Review your incorrect assumptions. What worried you the most? What was the consequence of having done those things or neglecting to do them? What could you do differently next time? Were your worries justified?'
              },
              {
                id: 'ed-3:3-a',
                da: ' Fake it until you believe it. Talk about the assignment or task as if you were truly excited. Identify all the positive results to be gained from taking action. Roll up your sleeves and do it. The reward for hard work is just an initiative away.'
              },
              {
                id: 'ed-3:3-b',
                da: ' Regular exercise helps to relieve stress, builds physical and mental stamina and raises energy levels. Include exercise as one of your tools for creating more energy in your life and work.'
              },
              {
                id: 'ed-3:3-c',
                da: ' Be sure to balance your life with things that bring you happiness. If you are not getting recharged outside of work, your energy will be sapped and your performance will lack luster.'
              },
              {
                id: 'ed-3:3-d',
                da: ' Help others to become excited even if you are not. Try not to sound bored or complain in the workplace. Encourage optimistic discussions about the future. Ask people to share their vision and hopes for their own or the organization\'s future. Make it a ritual part of your meetings. Ensure you are not hampering other\' progress by not, for example, getting work done on which they had counted.'
              },
              {
                id: 'ed-3:3-e',
                da: ' Observe how others do it. Identify people who are energizing and who create excitement about work. Spend time with them and tap into their energy.'
              },
              {
                id: 'ed-3:3-f',
                da: ' If you were once energetic but have lost your enthusiasm, examine what has changed about your situation. Is it work or something bigger? Talk to a mentor or coach who can help you to examine the factors that have led to your frame of mind, and the changes you could make.'
              },
              {
                id: 'ed-3:3-g',
                da: ' Would you feel more energetic if you had different responsibilities? Explore whether your position is suitable and, if not, which one would be. Consider new assignments that will begin a new chapter in your career and help you to tap into new energy.'
              },
              {
                id: 'ed-3:3-h',
                da: ' If your energy level is chronically low and you find it difficult to take initiative in anything, including personal issues, consider consulting a professional counselor or seeking medical advice.'
              },
              {
                id: 'ed-3:4-a',
                da: ' Do not wait to be told what to do or a crisis to force an issue. Look for tasks that remain incomplete or projects that could benefit from your participation.'
              },
              {
                id: 'ed-3:4-b',
                da: ' Talk to your supervisor about their expectations. They may feel threatened, or perhaps they are unaware that they discourage you from taking initiative. Try to uncover the reasons instead of making assumptions. You may be unfocused and they may need you to act proactively in other areas. Give them examples of concrete issues instead of generalizations.'
              },
              {
                id: 'ed-3:4-c',
                da: ' Share the credit with others when you can so that no one feels threatened by you taking initiative on your own.'
              },
              {
                id: 'ed-3:4-d',
                da: ' If you feel completely unable to take initiative in your position, consider a reassignment where your efforts will be recognized.'
              },
              {
                id: 'ed-3:5-a',
                da: ' Do not assume you will not be successful. If you lack resources, talk to the relevant people about making them available. If you are convincing enough, you will get the support you need.'
              },
              {
                id: 'ed-3:5-b',
                da: ' If you cannot do it on your own, mobilize others to take interest and share the project with you.'
              },
              {
                id: 'ed-3:5-c',
                da: ' Look for inspiration from within rather than outside. Others may not be motivated to provide direction, so be the one who stands out. The issue may not be a priority for others, but you can see the impact it will have, so remain determined and resilient.'
              },
              {
                id: 'ed-3:5-d',
                da: ' Make a case for the benefits of pursuing the course of action you are suggesting. Your efforts may not receive the appreciation you wanted, but at least you did your best. Perhaps your plan of action will be implemented when the timing is better.'
              },
              {
                id: 'ed-3:6-a',
                da: ' Do not assume you cannot make certain decisions. Find out what your level of authority is and within which parameters you need to work.'
              },
              {
                id: 'ed-3:6-b',
                da: ' Be proactive. If you have ideas about addressing a problem, consult the relevant people and explain how you propose to do it.'
              },
              {
                id: 'ed-3:6-c',
                da: ' Take charge of the situation first then stop at checkpoints along the way to ensure you are moving in the right direction.'
              },
              {
                id: 'ed-3:7-a',
                da: ' Spend time familiarizing yourself with the types of tools on which you can rely to do your job. Most organizations have made sizeable investments in resources such as software, trade journals and reference material. Set aside some time after work or during weekends, if necessary, to peruse your reference material.'
              },
              {
                id: 'ed-3:7-b',
                da: ' Ask peers and colleagues what they used to accomplish similar jobs. Conversations like these expose you to resources that may be available but of which you were unaware or never thought to utilize.'
              },
              {
                id: 'ed-3:7-c',
                da: ' If you do not have the resources you need at your disposal, cast the net wider. Look beyond your group or division or even your company to find the necessary ones.'
              },
              {
                id: 'ed-3:7-d',
                da: ' Enquire about training available from your human resources department and schedule time to attend it.'
              },
              {
                id: 'ed-3:7-e',
                da: ' Suggest informal gatherings, at lunch perhaps, where you and colleagues can share your know-how and train others informally.'
              },
              {
                id: 'ed-3:7-f',
                da: ' Immediately tell colleagues if you cannot take advantage of a resource or even use it. There is no shame in not knowing, but shame on you for not asking!'
              }
            ]
          },
          {
            id: 'ed-4',
            icon: require('@/assets/Iconography/Attributes/07-01_Achieving Goals.svg'),
            comp: 'Achieving Results',
            wdd: 'Delivering work on time requires planning and good time\n' +
                'management. People who have a high level of personal\n' +
                'responsibility are also more conscientious and make sure they\n' +
                'deliver on promises.',
            progressMeasures: [
              {
                id: 'ed-4-0',
                pm: 'Acheiving goals and performance targets for myself',
                pmMap: 'Achieve the goals and performance targets for myself'
              },
              {
                id: 'ed-4-1',
                pm: 'Setting a high standard for self',
                pmMap: 'Strive to do well and set a high standard for myself'
              },
              {
                id: 'ed-4-2',
                pm: 'Keep high energy and not get drained by obstacles',
                pmMap: 'Not let my energy get drained by obstacles'
              },
              {
                id: 'ed-4-3',
                pm: 'Learning to step back and recharge before tackling tasks that appear insurmountable',
                pmMap: 'Know how to step back and recharge before tackling tasks that appear insurmountable'
              }
            ],
            developmentActions: [
              {
                id: 'ed-4:1-a',
                da: 'As a rule, first do the things you do not want to do. You will have to do them anyway, and often they prevent you from working productively because you spend too much energy trying to avoid these few tasks. Write down what they are and enlist a co-worker to keep you on track.'
              },
              {
                id: 'ed-4:1-b',
                da: 'Focus on doing the things that matter most so that you spend your time wisely. If time overtakes you, you will at least have taken care of the items that have the most impact. Be specific about what these things are and create a priority list. Confirm with an appropriate person that you have prioritized accurately.'
              },
              {
                id: 'ed-4:1-c',
                da: 'Tackle the task in palatable increments. Work on things during breaks you may have between your commitments and appointments. It will ensure the amount of work is manageable and you will see increasing progress.'
              },
              {
                id: 'ed-4:1-d',
                da: 'Anticipate that everything will take longer to complete than you expected. Whatever the deadline, subtract time from it to give yourself impetus to start. Reward yourself every time you meet the deadline.'
              },
              {
                id: 'ed-4:1-e',
                da: 'Take action immediately. Limit the time between getting the assignment and starting to work. Sitting still too long without taking action can harm your motivation.'
              },
              {
                id: 'ed-4:1-f',
                da: 'If you perform best or are motivated by working with others, recruit peers with whom you can collaborate to get you started. They will also be able to help keep you on track, especially if your performance is tied to others.'
              },
              {
                id: 'ed-4:2-a',
                da: 'Limit the time you spend on a given assignment. Set points at which you will confer with your superior for feedback on the level of detail you should be achieving. This will help to keep your expectations of yourself realistic.'
              },
              {
                id: 'ed-4:2-b',
                da: 'Reframe your expectations. Aim for completing a task or assignment well, not making it perfect.'
              },
              {
                id: 'ed-4:3-a',
                da: 'Build flexibility into your schedule so that you can tackle a particular project at a time that makes sense for you. Many people mark specific time blocks off to work on an assignment, but if you are burnt out this may backfire because your inspiration and motivation will be inconsistent ” they cannot be scheduled. Take advantage of the times you feel ready to work on a project, even if it is just for a short period. Conversely, move on to something else if you are not producing anything. Spinning your wheels will build frustration and increase negative associations with the work at hand.'
              },
              {
                id: 'ed-4:3-b',
                da: 'Review and reward your progress continually. Break down the project into smaller tasks and reward yourself every time you accomplish a step.'
              },
              {
                id: 'ed-4:3-c',
                da: 'Be honest with your superior. They may be able to assist you by doing something simple such as helping you to delegate some of your work. Often, people do not like to inform their superior of problems because they do not want to appear as if they cannot handle the situation. Inevitably, though, burnout will show in your performance, so act before it does.'
              },
              {
                id: 'ed-4:3-d',
                da: 'Shake things up ” if you are chronically feeling burnt out it may be time to look for another position within the company or try something completely new. Spend time to investigate your options and set your goal.'
              },
              {
                id: 'ed-4:4-a',
                da: 'Focus on doing the things that matter most. Be specific about what they are and create a priority list. Confirm with your superior that you have prioritized well and accurately. require you to extend yourself.'
              },
              {
                id: 'ed-4:4-b',
                da: 'Which activities take up most of your time? Create a list of your activities and assign the approximate times you are spending on each category. Then divide the categories into essential and â€œneed to do. What does your time allotment look like? mistake, write a list of the benefits of having made the mistake â€” the specifics of what you have learned, who you met in the process and so forth.'
              },
              {
                id: 'ed-4:4-c',
                da: 'Are you delegating appropriately? In which tasks can you involve others? theme of risk taking among them.'
              },
              {
                id: 'ed-4:5-a',
                da: 'Slowly raise your risk comfort level by taking on smaller assignments that require you to extend yourself.'
              },
              {
                id: 'ed-4:5-b',
                da: 'View mistakes as opportunities to learn and reflect. Every time you make a mistake, write a list of the benefits of having made the mistake â€” the specifics of what you have learned, who you met in the process and so forth.'
              },
              {
                id: 'ed-4:5-c',
                da: 'Read biographies of business or public leaders who you admire. Look for a common theme of risk taking among them.'
              },
              {
                id: 'ed-4:5-d',
                da: 'You may have taken more risk than you have thought or given yourself credit for. Document your accomplishments. What risks did each of these accomplishments involve? Write them down, regardless how small the risk was. Ask people who know you well to help you. The objective is to show that all careers are based on a combination of challenges to which we are continuously called upon to rise. You may already be more of a risk taker than you think.'
              },
              {
                id: 'ed-4:6-a',
                da: 'If you do not have a work plan yet, meet with your superior to develop one with specific goals and targets for each year. Agree to reassess your work plan occasionally to make any changes necessary.'
              },
              {
                id: 'ed-4:6-b',
                da: 'Be prepared to ask your supervisor and peers about your performance and whether you are meeting their expectations.'
              },
              {
                id: 'ed-4:6-c',
                da: 'Take a cue from peers that are known high performers. Compare your standard of work to theirs â€” do not rely on your own perception. Use their assessment as a yardstick to measure your level of accomplishment.'
              }
            ]
          },
          {
            id: 'ed-5',
            icon: require('@/assets/Iconography/Attributes/07-02_Advancing My Career.svg'),
            comp: 'Advancing to Next Level',
            wdd: 'Being responsive requires a degree of flexibility which allows\n' +
                'you to re-prioritize tasks so that you can react quickly to\n' +
                'changing needs. It also requires a sense of urgency and a\n' +
                'commitment to do more than only what is required.',
            progressMeasures: [
              {
                id: 'ed-5-0',
                pm: 'I usually feel confident that I can succeed in any role or position I choose to do',
                pmMap: 'Feel confident that I can succeed in any role or position I choose to do'
              },
              {
                id: 'ed-5-1',
                pm: 'I am clear about what I need to do to advance my career',
                pmMap: 'Be clear about what I need to do to advance my career'
              },
              {
                id: 'ed-5-2',
                pm: 'I am taking the necessary action to work towards career advancement',
                pmMap: 'Take the necessary action to work towards career advancement'
              },
              {
                id: 'ed-5-3',
                pm: 'I discuss my future plans with my people who can help me achieve them',
                pmMap: 'Discuss my future plans with my people who can help me achieve them'
              }
            ],
            developmentActions: [
              {
                id: 'ed-5:1-a',
                da: ' Every day, visualize the things you want in your life and career. A growing movement believes in the power of visualization to attract what we need in our lives. Read The Secret by Rhonda Byrne.'
              },
              {
                id: 'ed-5:1-b',
                da: ' Positive affirmation can help to rewire your thinking. Be vigilant against negative thoughts about yourself and practice to replace them with positive ones immediately.'
              },
              {
                id: 'ed-5:1-c',
                da: ' Identify a few people who you admire for their self-confidence and talk to them about their views on the world. Note the differences in your thinking styles.'
              },
              {
                id: 'ed-5:1-d',
                da: ' Do not give mistakes more importance than they deserve. Write down the worst-case scenarios and analyze them. Unless your life or someone else\'s is at stake, the worst is never as bad as you might think.'
              },
              {
                id: 'ed-5:1-e',
                da: ' Read about people who have made mistakes but still succeeded, such as Thomas Edison. It took 10 000 failures to make the light bulb!'
              },
              {
                id: 'ed-5:1-f',
                da: ' You do not need to have all the answers. Work the part of your plan that you can, and ask for help with the rest.'
              },
              {
                id: 'ed-5:1-g',
                da: ' Extend your comfort zone. You are building confidence every time you take on a new challenge or task. Keep score of the new challenges you have overcome.'
              },
              {
                id: 'ed-5:1-h',
                da: ' Understand what your challenges will be if you were to move to a new position or role. List the things you are potentially uncomfortable doing. It could be managing people for the first time, networking more than usual or learning more about a specific technical area. Be as detailed as possible with your list. Which items on the list are perceived challenges and which ones are real? For example, you may not have supervised people before but work well with others, are approachable, patient, manage conflict well etcetera. All these behaviors point to your likely success as a leader.'
              },
              {
                id: 'ed-5:1-i',
                da: ' Learn more about the position you are interested in by spending time with the incumbent or someone in a similar role. Find out what they regard as the greatest challenges of the position. The more you know the better equipped you will be to start the job without being blindsided by unexpected demands.'
              },
              {
                id: 'ed-5:1-j',
                da: ' If you believe you truly lack the skills critical to getting a promotion, talk to your supervisor about devising a development plan that involves key assignments and experiences to help build your skills set. Make sure you communicate both your interest and your concern about shortcomings.'
              },
              {
                id: 'ed-5:1-k',
                da: ' In the end, no amount of preparation will guarantee you are 100% ready for a position. If the opportunity is available and you want to do it, stop thinking and take action.'
              },
              {
                id: 'ed-5:1-l',
                da: ' If you find that your lack of self-confidence is affecting your ability to function and advance in your career, seek the help of a professional coach or counselor as part of your development plan. A trained therapist can help you to challenge deep-rooted thinking patterns.'
              },
              {
                id: 'ed-5:2-a',
                da: ' Revisit your career goals. Are you still on track? Is your lack of motivation due to your current assignment or another temporary circumstance, or is the problem your position itself?'
              },
              {
                id: 'ed-5:2-b',
                da: ' Identify the specific needs that are not being met by your position. Assessment tools such as the Birkman method scrutinizes individuals\' less obvious needs that are not met in their work environment and professional relationships. Other factors may be more obvious, such as salary, your relationship with your boss or a lack of challenging assignments. The app has a motivation survey which addresses motivational areas.'
              },
              {
                id: 'ed-5:2-c',
                da: ' Talk to your supervisor about the role you envision for yourself and how the opportunity can be created. Be honest - your supervisor may be thinking you are perfectly content with your situation.'
              },
              {
                id: 'ed-5:2-d',
                da: ' It is important to keep the momentum going when you are unmotivated. Identify three actions to complete in the next month that could help you to regain interest in your career.'
              },
              {
                id: 'ed-5:2-e',
                da: ' Try to visualize yourself doing something new. What would be your dream position in the organization? It makes sense to create a vision of your future then focus strategically on how to get there.'
              },
              {
                id: 'ed-5:2-f',
                da: ' Continue to look for opportunities within the company by networking and trying new roles until you find a project, assignment or job that motivates you.'
              },
              {
                id: 'ed-5:3-a',
                da: ' Put a plan in place for your career advancement. Let your supervisor help to identify the competencies, experience and technical skills you will need to get promoted.'
              },
              {id: 'ed-5:3-b', da: ' Take the initiative to find out about positions open in your company.'},
              {
                id: 'ed-5:3-c',
                da: ' Become knowledgeable about the skills considered scarce in your industry. Companies make extra efforts to retain employees with these skills.'
              },
              {
                id: 'ed-5:3-d',
                da: ' Try to visualize yourself doing something new. What would your dream opportunity in the organization be? It makes sense to create a vision of your future then focus strategically on how to get there.'
              },
              {
                id: 'ed-5:3-e',
                da: ' Make time to network. Talking to people and getting more exposure increase your chances of discovering new ways to raise your visibility and advance your career.'
              },
              {
                id: 'ed-5:3-f',
                da: ' Take growth one small step at a time if you are not comfortable with drastic changes or do not really know which step to take next. Experiment with new assignments that test different skills. It may surprise you to discover other things at which you are really talented. You will find yourself getting more comfortable doing different assignments the more diverse your experiences become.'
              },
              {
                id: 'ed-5:3-g',
                da: ' Inquire about short-term opportunities in your company, perhaps in a new department, if this could help you to advance towards your long-term goals.'
              },
              {
                id: 'ed-5:3-h',
                da: ' Read The Leadership Pipeline by Ram Charan and Stephen Drotter, which describes the competencies necessary to function successfully throughout different organizational levels.'
              },
              {
                id: 'ed-5:4-a',
                da: ' Can you pinpoint the reasons why you are feeling so burnt out? Which things within your control can change and which cannot? You will be surprised to see how changing one or two factors can provide the room you need to re-energize. Get feedback from family, peers or a coach about what those factors could be. Sometimes we find it hard to see what seem obvious to those around us.'
              },
              {
                id: 'ed-5:4-b',
                da: ' Is your workload reasonable and realistic? Talk to the relevant people about your work distribution if that contributes greatly to your burnout.'
              },
              {
                id: 'ed-5:4-c',
                da: ' Make sure you recharge daily with exercise or a hobby that helps to take your mind off work.'
              },
              {
                id: 'ed-5:4-d',
                da: ' Which aspects of the opportunity being offered do you like and which ones put you off? Which terms are negotiable? Typically, there are ways to tailor a promotion to better fit your needs.'
              },
              {
                id: 'ed-5:4-e',
                da: ' Observe successful people in your organization who have demanding jobs but keep a balance between their professional and private lives. Learn how they do it.'
              },
              {
                id: 'ed-5:4-f',
                da: ' Take a breather before making a decision. Take some time off to relax and think clearly. Whatever your decision upon your return, it will be based on a better perspective.'
              },
              {id: 'ed-5:5-a', da: ' Write down the pros and cons of staying in the same position.'},
              {
                id: 'ed-5:5-b',
                da: ' Identify a position that truly piques your interest and for which you would be willing to make sacrifices. Keep searching if you cannot identify something now.'
              },
              {
                id: 'ed-5:5-c',
                da: ' Even if you are not ready for a promotion, keep discussing possibilities with your peers and supervisor to demonstrate your interest.'
              },
              {
                id: 'ed-5:5-d',
                da: ' Talk to people in other positions a level or two above yours. Ask how they like their jobs and what the principal benefits are.'
              },
              {
                id: 'ed-5:5-e',
                da: ' Find out as much as possible about the position under consideration. It is common to make incorrect assumptions about the responsibilities a position entails. Talk to the incumbent, if possible, or others who have been in a similar role.'
              },
              {
                id: 'ed-5:5-f',
                da: ' Engage a coach to examine in depth the reasons why you are not interested in taking on more responsibility.'
              },
              {
                id: 'ed-5:6-a',
                da: ' Approach your self-promotion like you would any other business endeavor and create a personal marketing plan. Establish the actions you will undertake and hold yourself accountable weekly.'
              },
              {id: 'ed-5:6-b', da: ' Create a weekly status report to inform your boss about your accomplishments.'},
              {
                id: 'ed-5:6-c',
                da: ' Communicate your efforts to all your stakeholders, not just your peers or manager. If appropriate, consider informing your clients, senior management and business network.'
              },
              {
                id: 'ed-5:6-d',
                da: ' Learn to create a brief statement that communicates the highlights of your success without providing unnecessary details.'
              },
              {
                id: 'ed-5:6-e',
                da: ' Be wary of being too modest. Are you deflecting praise too quickly? Accept welldeserved praise graciously and with pride.'
              },
              {
                id: 'ed-5:6-f',
                da: ' Do not accept blame too quickly. You are accountable for your actions, not other people\'s mistakes. Taking blame when it is undeserved dilutes perceptions of your contribution.'
              },
              {
                id: 'ed-5:6-g',
                da: ' You may be more comfortable promoting your group\'s effort, which gives you a chance to highlight your role but share the accolades.'
              },
              {
                id: 'ed-5:6-h',
                da: ' Prepare well for your performance reviews. You must be able to highlight accomplishments and provide supporting documentation for the less obvious goals you have met.'
              },
            ]
          },
          {
            id: 'ed-6',
            icon: require('@/assets/Iconography/Attributes/07-03_Being Determined.svg'),
            comp: 'Being determined',
            wdd: 'The more direction a manager has to provide to someone in\n' +
                'order to get there job done, the more time and effort it\n' +
                'requires from that manager. The better you know you job, the\n' +
                'more independently you can operate and this is a quality that\n' +
                'managers value in high performers.',
            progressMeasures: [
              {
                id: 'ed-6-0',
                pm: 'I rarely quit before I have completed a task or project',
                pmMap: 'Rarely quit before I have completed a task or project'
              },
              {
                id: 'ed-6-1',
                pm: 'I recover quickly from emotional setbacks during a project',
                pmMap: 'Recover quickly from emotional setbacks during a project'
              },
              {
                id: 'ed-6-2',
                pm: 'I have completed long-term projects successfully',
                pmMap: 'Completing long-term projects successfully'
              },
              {
                id: 'ed-6-3',
                pm: 'I do not like leaving anything incomplete',
                pmMap: 'Not leave things incomplete'
              }
            ],
            developmentActions: [
              {
                id: 'ed-6:1-a',
                da: ' Ensure that new initiatives are introduced in a manner that creates buy-in from all stakeholders and that the infrastructure and resources exist to facilitate the appropriate follow-through.'
              },
              {
                id: 'ed-6:1-b',
                da: ' Celebrate small goals or milestones along the way. It may take a while to realize the project completely, and acknowledging the steps needed to get there will keep you motivated.'
              },
              {
                id: 'ed-6:1-c',
                da: ' Make progress, not inspiration, your primary goal. It means you must focus on the steps necessary to mature an existing product or service instead of trying to generate new ones. Make a detailed plan of the steps necessary to translate the idea into practice. Once you have identified these steps in your plan, you can apply the same framework for future ideas.'
              },
              {
                id: 'ed-6:1-d',
                da: ' Be sure to monitor your work processes. Once distracted by new initiatives, it is easy to abandon the monitoring of existing projects\' progress. Why compromise the hard work and resources that have been invested because of a lack of oversight?'
              },
              {
                id: 'ed-6:1-e',
                da: ' Find a trusted peer that can cheer you on when you are struggling. An external perspective to remind you how close you are to your goal, or simply someone to listen to your feelings can be just the life vest you need when you are least inspired.'
              },
              {
                id: 'ed-6:1-f',
                da: ' Have you lost sight of your vision? Occasionally, reflect on the bigger picture and what it was that excited you about the work in the first place.'
              },
              {
                id: 'ed-6:1-g',
                da: ' First complete the things you least like doing and get them out of the way while your motivation is highest. It will be easier to tackle the less complex tasks when you have less energy.'
              },
              {
                id: 'ed-6:1-h',
                da: ' If you simply cannot get excited about working on a particular assignment or task, you may need some time to recharge by focusing on something else. Taking a break from the task at hand will give you a chance to recharge. Can you ask for assistance?'
              },
              {
                id: 'ed-6:1-i',
                da: ' If you are not a detail-oriented person, you are likely to lose interest quickly and prefer to move on to something new. Make sure there are people on your team who are more analytical or concerned with detail and can drive that aspect of the project.'
              },
              {
                id: 'ed-6:1-j',
                da: ' Certainly, some aspects of everyone\'s jobs are less interesting than others, but if nothing holds your interest or you are chronically bored, you should consider whether your position is right for you.'
              },
              {
                id: 'ed-6:2-a',
                da: ' Keep things as simple as possible by narrowing your focus to one or two core drivers of the problem. Articulate what those drivers are.'
              },
              {
                id: 'ed-6:2-b',
                da: ' Focus on the starting point and not the finishing line. What is most important as a first course of action? List all the possibilities and choose only a few avenues on which to focus for now. There is never a perfect place from which to start. Once you have accomplished the initial steps, begin again.'
              },
              {
                id: 'ed-6:2-c',
                da: ' Assemble a strong team that has multiple skills and can tackle all the various angles of the project. You do not have to be an expert in every aspect.'
              },
              {
                id: 'ed-6:2-d',
                da: ' Do not linger on a problem too long before addressing it. The longer you leave an issue unaddressed the more overwhelming it becomes.'
              },
              {
                id: 'ed-6:3-a',
                da: ' Often, once you gain a better perspective or have more information, obstacles are not as difficult to overcome as they first appeared. Ask a trusted colleague or expert to provide a different perspective. Someone else might be able to see an obvious solution that you cannot just then.'
              },
              {
                id: 'ed-6:3-b',
                da: ' Use obstacles as opportunities to have fun while being creative. There are always multiple ways to approach an issue. Do you need to start over again or simply change your course of action? Many plans have failed not because they were not good, but because they were inflexible.'
              },
              {
                id: 'ed-6:3-c',
                da: ' Your biggest obstacle may be your emotions or attitude. Examine the real reasons why you are contemplating giving up and make sure the reasons are based on logic, not emotion.'
              },
              {
                id: 'ed-6:3-d',
                da: ' Reflect on your original purpose for embarking on this route and become motivated again. Sometimes a shot of energy is all you need to get you over the hurdle.'
              },
              {
                id: 'ed-6:4-a',
                da: ' Always add to your timelines to allow for contingencies. You want to start with a realistic timeframe for completion and mitigate unnecessary frustration.'
              },
              {
                id: 'ed-6:4-b',
                da: ' Do you have other things on your plate? There is no reason not to move on to another project if you are simply not able to focus on a specific task at the moment, but be sure to return at a later stage to address what you had left behind.'
              },
              {
                id: 'ed-6:4-c',
                da: ' Rather than give up altogether because things are not moving fast enough, find ways to improve the process so that it can be completed more quickly. This might involve recruiting additional resources to help.'
              },
              {
                id: 'ed-6:4-d',
                da: ' Does the whole task have to be done from beginning to end at once? Divide it into smaller tasks on which you can work progressively.'
              }
            ]
          },
          {
            id: 'ed-7',
            icon: require('@/assets/Iconography/Attributes/07-04_Taking Initiative.svg'),
            comp: 'Taking initiative',
            wdd: 'Opportunities will always arise to do things more effectively,\n' +
                'and these opportunities cannot be captured in a job\n' +
                'description or list of tasks. Seeing, and taking these\n' +
                'opportunities means having a problem solving mindset and\n' +
                'requires a willingness to take calculated risks that could lead to\n' +
                'better ways of doing things.',
            progressMeasures: [
              {
                id: 'ed-7-0',
                pm: 'I am excited about my work',
                pmMap: 'Demonstrate excitement about my work'
              },
              {
                id: 'ed-7-1',
                pm: 'If I see things that must be done, I am proactive and get involved',
                pmMap: 'See things that must be done, and proactively get involved'
              },
              {
                id: 'ed-7-2',
                pm: 'I do not wait to be told what work to do',
                pmMap: 'Not wait to be told what work to do'
              },
              {
                id: 'ed-7-3',
                pm: 'I take initiative even if the decision is risky',
                pmMap: 'Take initiative even if the decision is risky'
              }
            ],
            developmentActions: [
              {
                id: 'ed-7:1-a',
                da: ' Are you assuming you lack the necessary skills before you really know what an assignment entails? If you lack confidence in your skills, you are likely to make quick judgments not necessarily based on facts. Talk to relevant people about what is really needed. Ensure your expectations of yourself compare with those your superior has of you. If you are usually hard on yourself, you are probably overestimating what you need to know to get going.'
              },
              {
                id: 'ed-7:1-b',
                da: ' If your skills set is insufficient for the task at hand, take initiative by recruiting someone else to work with you. You can learn from this person and contribute your strengths at the same time. Use a suitable, knowledgeable peer as a sounding board for ideas.'
              },
              {
                id: 'ed-7:1-c',
                da: ' Volunteer to do assignments that will challenge and extend your abilities. List the things you are least comfortable doing. Resolve to do at least one task or assignment every month that will help you to develop a weak area.'
              },
              {
                id: 'ed-7:1-d',
                da: ' Formulate an individual development plan with your supervisor or coach to address areas in which you particularly lack confidence. Why wait to address a weakness when you can have an ongoing development strategy designed to improve it?'
              },
              {
                id: 'ed-7:1-e',
                da: ' Remind yourself of other times when you were apprehensive about tackling a challenge. What was the result? Did your level of skill derail the project?'
              },
              {
                id: 'ed-7:1-f',
                da: ' If you do not know where to begin, take the initiative by being resourceful. Find out who can help with particular tasks; investigate the work that was done in similar projects and the reference material available to get you up to speed. Instead of spinning your wheels anxiously, start asking the right questions.'
              },
              {
                id: 'ed-7:2-a',
                da: ' Weigh the likelihood of the situation or decision\'s complete failure, and the degree of damage should the worst-case scenario materialize. Reality tends to be less severe than perception. Talk to a trusted peer or mentor who can be a sounding board for your concerns. They can help to provide perspective. Do they think the situation is as risky as you do?'
              },
              {
                id: 'ed-7:2-b',
                da: ' Become comfortable making decisions without complete data. Practice trusting your intuition. In his book Blink, Malcom Gladwell champions the power of using intuition in decision making. Start with small decisions and progress to ones with bigger consequences.'
              },
              {
                id: 'ed-7:2-c',
                da: ' Get used to making decisions regardless of conventional wisdom or the level of support they enjoy. Taking initiative will sometimes mean paving a new way all on your own.'
              },
              {
                id: 'ed-7:2-d',
                da: ' Pair with someone who is more risk-tolerant and can help you to take initiative in projects beyond your comfort zone.'
              },
              {
                id: 'ed-7:2-e',
                da: ' Identify beforehand the risks associated with your work, business, project etcetera. Having a plan to manage risk, should it become an issue, will give you a greater sense of control.'
              },
              {
                id: 'ed-7:2-f',
                da: ' Do reflection after projects, on your own and with your team. Review your incorrect assumptions. What worried you the most? What was the consequence of having done those things or neglecting to do them? What could you do differently next time? Were your worries justified?'
              },
              {
                id: 'ed-7:3-a',
                da: ' Fake it until you believe it. Talk about the assignment or task as if you were truly excited. Identify all the positive results to be gained from taking action. Roll up your sleeves and do it. The reward for hard work is just an initiative away.'
              },
              {
                id: 'ed-7:3-b',
                da: ' Regular exercise helps to relieve stress, builds physical and mental stamina and raises energy levels. Include exercise as one of your tools for creating more energy in your life and work.'
              },
              {
                id: 'ed-7:3-c',
                da: ' Be sure to balance your life with things that bring you happiness. If you are not getting recharged outside of work, your energy will be sapped and your performance will lack luster.'
              },
              {
                id: 'ed-7:3-d',
                da: ' Help others to become excited even if you are not. Try not to sound bored or complain in the workplace. Encourage optimistic discussions about the future. Ask people to share their vision and hopes for their own or the organization\'s future. Make it a ritual part of your meetings. Ensure you are not hampering other\' progress by not, for example, getting work done on which they had counted.'
              },
              {
                id: 'ed-7:3-e',
                da: ' Observe how others do it. Identify people who are energizing and who create excitement about work. Spend time with them and tap into their energy.'
              },
              {
                id: 'ed-7:3-f',
                da: ' If you were once energetic but have lost your enthusiasm, examine what has changed about your situation. Is it work or something bigger? Talk to a mentor or coach who can help you to examine the factors that have led to your frame of mind, and the changes you could make.'
              },
              {
                id: 'ed-7:3-g',
                da: ' Would you feel more energetic if you had different responsibilities? Explore whether your position is suitable and, if not, which one would be. Consider new assignments that will begin a new chapter in your career and help you to tap into new energy.'
              },
              {
                id: 'ed-7:3-h',
                da: ' If your energy level is chronically low and you find it difficult to take initiative in anything, including personal issues, consider consulting a professional counselor or seeking medical advice.'
              },
              {
                id: 'ed-7:4-a',
                da: ' Do not wait to be told what to do or a crisis to force an issue. Look for tasks that remain incomplete or projects that could benefit from your participation.'
              },
              {
                id: 'ed-7:4-b',
                da: ' Talk to your supervisor about their expectations. They may feel threatened, or perhaps they are unaware that they discourage you from taking initiative. Try to uncover the reasons instead of making assumptions. You may be unfocused and they may need you to act proactively in other areas. Give them examples of concrete issues instead of generalizations.'
              },
              {
                id: 'ed-7:4-c',
                da: ' Share the credit with others when you can so that no one feels threatened by you taking initiative on your own.'
              },
              {
                id: 'ed-7:4-d',
                da: ' If you feel completely unable to take initiative in your position, consider a reassignment where your efforts will be recognized.'
              },
              {
                id: 'ed-7:5-a',
                da: ' Do not assume you will not be successful. If you lack resources, talk to the relevant people about making them available. If you are convincing enough, you will get the support you need.'
              },
              {
                id: 'ed-7:5-b',
                da: ' If you cannot do it on your own, mobilize others to take interest and share the project with you.'
              },
              {
                id: 'ed-7:5-c',
                da: ' Look for inspiration from within rather than outside. Others may not be motivated to provide direction, so be the one who stands out. The issue may not be a priority for others, but you can see the impact it will have, so remain determined and resilient.'
              },
              {
                id: 'ed-7:5-d',
                da: ' Make a case for the benefits of pursuing the course of action you are suggesting. Your efforts may not receive the appreciation you wanted, but at least you did your best. Perhaps your plan of action will be implemented when the timing is better.'
              },
              {
                id: 'ed-7:6-a',
                da: ' Do not assume you cannot make certain decisions. Find out what your level of authority is and within which parameters you need to work.'
              },
              {
                id: 'ed-7:6-b',
                da: ' Be proactive. If you have ideas about addressing a problem, consult the relevant people and explain how you propose to do it.'
              },
              {
                id: 'ed-7:6-c',
                da: ' Take charge of the situation first then stop at checkpoints along the way to ensure you are moving in the right direction.'
              },
              {
                id: 'ed-7:7-a',
                da: ' Spend time familiarizing yourself with the types of tools on which you can rely to do your job. Most organizations have made sizeable investments in resources such as software, trade journals and reference material. Set aside some time after work or during weekends, if necessary, to peruse your reference material.'
              },
              {
                id: 'ed-7:7-b',
                da: ' Ask peers and colleagues what they used to accomplish similar jobs. Conversations like these expose you to resources that may be available but of which you were unaware or never thought to utilize.'
              },
              {
                id: 'ed-7:7-c',
                da: ' If you do not have the resources you need at your disposal, cast the net wider. Look beyond your group or division or even your company to find the necessary ones.'
              },
              {
                id: 'ed-7:7-d',
                da: ' Enquire about training available from your human resources department and schedule time to attend it.'
              },
              {
                id: 'ed-7:7-e',
                da: ' Suggest informal gatherings, at lunch perhaps, where you and colleagues can share your know-how and train others informally.'
              },
              {
                id: 'ed-7:7-f',
                da: ' Immediately tell colleagues if you cannot take advantage of a resource or even use it. There is no shame in not knowing, but shame on you for not asking!'
              }
            ]
          }

        ]
      },
      'pm': {
        characteristic: 'Leader Performance Template',
        wdd: "Evaluate performance of a manager on providing clear objectives and instructions to others; assigning meaningful and important tasks and responsibilities to others and giving them authority to act; putting useful and meaningful measures in place to monitor work processes.",
        icon: require('@/assets/Iconography/Characteristics/12_People Manager.svg'),
        competencies: [
          {
            id: 'pm-0',
            icon: require('@/assets/Iconography/Attributes/12-03_Empowering People.svg'),
            comp: 'Empowering people',
            wdd: 'Creating high levels of energy in a team requires high\n' +
                'levels of personal energy because most people will copy\n' +
                'what they see. Understanding and being able to apply\n' +
                'different motivational techniques that reward and recognize\n' +
                'contributions and unify people is important to get the best\n' +
                'out of a team. People will also contribute more discretionary\n' +
                'effort to a task if they feel appreciated and connect with the\n' +
                'person they work for.',
            progressMeasures: [
              {
                id: 'pm-0-0',
                pm: 'I give people the authority to make decisions without my approval',
                pmMap: 'Give people the authority to make decisions without my approval'
              },
              {
                id: 'pm-0-1',
                pm: 'I support other people’s decisions once they have made them',
                pmMap: 'Support other people’s decisions once they have made them'
              },
              {
                id: 'pm-0-2',
                pm: 'I remain composed and reassure people when they make mistakes',
                pmMap: 'Remain composed and reassure people when they make mistakes'
              },
              {
                id: 'pm-0-3',
                pm: 'I consider carefully the type of resources and support a person may need to complete an assignment successfully',
                pmMap: 'Carefully consider the type of resources and support a person may need to complete an assignment successfully'
              },
              {
                id: 'pm-0-4',
                pm: 'I delegate meaningful responsibilities to others, not tasks just to keep them busy',
                pmMap: 'Delegate meaningful responsibilities to others, not tasks just to keep them busy'
              }
            ],
            developmentActions: [
              {
                id: 'pm-0:1-a',
                da: ' Focus on the process and not only the people. Set your controls by planning work processes well. Invest time beforehand to lay out clear timeframes, goals and instructions. Once you have provided directives, allow people to follow them and test your controls.'
              },
              {
                id: 'pm-0:1-b',
                da: ' Give people tasks that are meaningful, not just stuff to keep them busy. Be sure to also give individuals the sort of responsibility that would make a difference in their careers.'
              },
              {
                id: 'pm-0:1-c',
                da: ' Use assessment tools to better understand the talent and strengths of individuals in your team, and delegate accordingly. For example, someone with strong persuasion skills can be assigned to lead the negotiation phase of an assignment.'
              },
              {
                id: 'pm-0:1-d',
                da: ' Ask people what they would like to do and give them opportunities to explore that interest.'
              },
              {
                id: 'pm-0:1-e',
                da: ' Delegate equitably. Examine to whom it is you usually delegate and why. Leaders have a tendency to delegate to those who have performed well previously, at the expense of others who may do just as well with a little more guidance.'
              },
              {
                id: 'pm-0:1-f',
                da: ' Consider experience level, timeframes and resources available when delegating an assignment. Ensure your expectations are realistic, based on all of the above, so that you do not set someone up for failure. Impossible tasks do not empower people.'
              },
              {
                id: 'pm-0:2-a',
                da: ' Verbalize clearly to subordinates that you give them authority to make decisions on their own. Having responsibilities is not empowering if one has to run every decision by one\'s manager. By nature, people are cautious about making wrong decisions, so if in doubt they will probably ask for approval.'
              },
              {
                id: 'pm-0:2-b',
                da: ' Establish a culture of trust. Make it clear that people are expected to manage their own work and that you are available when they need assistance.'
              },
              {
                id: 'pm-0:2-c',
                da: ' Agree to checkpoints in the process where you will review a person\'s work. In between these points, refrain from crowding the person.'
              },
              {
                id: 'pm-0:2-d',
                da: ' Regardless of how much you would want a task to be done in a particular way, remind yourself that there are many approaches. You may learn something new if you give someone freedom.'
              },
              {
                id: 'pm-0:2-e',
                da: ' If you are uncomfortable giving a person responsibility, team them with a stronger performer. Help them to evaluate the experience once the project is finished.'
              },
              {
                id: 'pm-0:2-f',
                da: ' Assume that extra time will be needed when someone is new to an assignment or testing new skills. It gives the person room to succeed in their assignment and learn at the same time.'
              },
              {
                id: 'pm-0:2-g',
                da: ' Delegate meaningful responsibilities that have a substantial impact. Constantly getting menial tasks is demoralizing and does little to empower people.'
              },
              {
                id: 'pm-0:2-h',
                da: ' During delegation you may well discover someone who does not perform in a certain area. Use this as an opportunity to discover their strengths or find the necessary interventions. If someone continually underperforms, despite your best attempts, you can choose development, reassignment, or let the person go.'
              },
              {
                id: 'pm-0:3-a',
                da: ' Take the lead in your team when it is sensible to do so. It is not always necessary to wait for your supervisor to delegate. Coordinate with your peers which tasks each will do and encourage others to cultivate new skills.'
              },
              {
                id: 'pm-0:3-b',
                da: ' If you are particularly skilled in an area, invite other team members to work with you on that aspect.'
              },
              {
                id: 'pm-0:3-c',
                da: ' Readily share interesting and new information or insights you have recently acquired.'
              },
              {
                id: 'pm-0:3-d',
                da: ' Observe other leaders who are good at empowering their team. Note what the person does well. Ask why people like working for that person.'
              },
              {
                id: 'pm-0:3-e',
                da: ' Tell your manager that you would like to gain experience in managing others and discuss the opportunities for you to do so. You may be assigned as team leader on a particular project, or perhaps serve in a special committee. Ask for increased authority in decision making and delegation.'
              },
              {
                id: 'pm-0:3-f',
                da: ' There are many opportunities to empower others outside of work. Practice your empowerment skills with your family members and through any groups or associations in which you are involved.'
              }
            ]
          },
          {
            id: 'pm-1',
            icon: require('@/assets/Iconography/Attributes/12-02_Monitoring Work.svg'),
            comp: 'Monitoring work',
            wdd: 'Getting access to resources as a manager is competitive,\n' +
                'because resources are limited and whatever you get,\n' +
                'someone else loses. In order to secure the resource you will\n' +
                'need, you first have to know where to find them, who to speak\n' +
                'to and how to negotiate. Once you have the resources you\n' +
                'need, you need to prioritize and decide when, how and to\n' +
                'who you will distribute those resources to be most effective.\n' +
                'Making the most of the resources you have requires a\n' +
                'practical and resourceful mind.',
            progressMeasures: [
              {
                id: 'pm-1-0',
                pm: 'I set milestones for each significant target in a process',
                pmMap: 'Set milestones for each significant target in a process'
              },
              {
                id: 'pm-1-1',
                pm: 'I consult others for their input and perceptions about how work is progressing',
                pmMap: 'Consult others for their input and perceptions about how work is progressing'
              },
              {
                id: 'pm-1-2',
                pm: 'I provide regular feedback to others so that adjustments can be made throughout the process',
                pmMap: 'Provide regular feedback to others so that adjustments can be made throughout the process'
              },
              {
                id: 'pm-1-3',
                pm: 'When necessary, I recalculate schedules and reset milestones as outcomes dictate',
                pmMap: 'Recalculate schedules and reset milestones as outcomes dictate'
              },
              {
                id: 'pm-1-4',
                pm: 'I believe it is as important to monitor work progress as it is to have a plan',
                pmMap: 'Monitor work progress against a plan'
              }
            ],
            developmentActions: [
              {
                id: 'pm-1:1-a',
                da: ' Develop a communication plan for regular dialogue with your team regarding the process\'s status and necessary modifications. This can take the form of weekly updating e-mails, formal meetings or informal conversations, shared folders for pertinent documents etcetera. Regular feedback ensures that people have direction along the way.'
              },
              {
                id: 'pm-1:1-b',
                da: ' Look for less obvious signs of problems in the process. For example, people may be meeting deadlines but feel undue stress, or lack essential resources, which can be demoralizing and cause burnout.'
              },
              {
                id: 'pm-1:1-c',
                da: ' Post and distribute a progress report, using a Gantt chart, project management evaluation and review technique (PERT'
              },
              {
                id: 'pm-1:1-d',
                da: ' Be sure to monitor processes more closely at the beginning of a project, until you are comfortable that everyone understands their roles and has clear direction.'
              },
              {id: 'pm-1:1-e', da: ' Verify that milestones are achieved and that tasks are on schedule and budget.'},
              {
                id: 'pm-1:1-f',
                da: ' Ensure that people are honest about the status of their tasks - ask them to show you the work they have completed so far. People may be reluctant to tell you their work status if they have fallen behind. Trust your instincts. You may discover that your team needs more resources or better clarification of tasks.'
              },
              {
                id: 'pm-1:1-g',
                da: ' Arrange a debriefing to document and discuss lessons learnt so that people know how to work more effectively in the future. Share these lessons with others in your organization as well.'
              },
              {
                id: 'pm-1:2-a',
                da: ' Nurture an environment in which you are regularly informed. Let people know it is important that they keep you up to date with their status without you having to solicit the information. For example, ask people to routinely send you brief status e-mails.'
              },
              {
                id: 'pm-1:2-b',
                da: ' Set up systems that facilitate quick monitoring, for example, utilize shared project management tools to quickly review online the status of milestones and budgets.'
              },
              {
                id: 'pm-1:2-c',
                da: ' If monitoring is difficult to manage on your own, delegate different aspects of the process to the team and hold debriefing meetings regularly.'
              },
              {
                id: 'pm-1:2-d',
                da: ' Invest more time in the beginning of the process, when more direction is needed, so that less of your time is required later.'
              },
              {
                id: 'pm-1:2-e',
                da: ' Limit the amount of time you spend with people who are giving you a status update. Do not let them ramble on or talk about irrelevant issues.'
              },
              {
                id: 'pm-1:3-a',
                da: ' Become involved in an assignment that involves planning and offer to work with your boss or other team members to establish milestones and progress measures.'
              },
              {
                id: 'pm-1:3-b',
                da: ' Do research and evaluate best practices for monitoring processes and their improvement.'
              },
              {
                id: 'pm-1:3-c',
                da: ' Become familiar with tools available to you, such as progress reports or charts (Gantt, PERT or CPM'
              },
              {
                id: 'pm-1:3-d',
                da: ' Utilize non-threatening methods of monitoring at first, such as debriefings, and then introduce more structured practices when people will accept them more easily.'
              },
              {
                id: 'pm-1:3-e',
                da: ' Find a respected person in the organization who will share their lessons in both successful and unsuccessful workflow monitoring with you. Although it is not a substitute for personal experience, it is useful to listen to what others have experienced.'
              },
              {
                id: 'pm-1:3-f',
                da: ' Document the lessons learnt from your experiences for use in monitoring future processes: what should have happened, could have been avoided or done differently?'
              }
            ]
          },
          {
            id: 'pm-2',
            icon: require('@/assets/Iconography/Attributes/12-01_Directing People.svg'),
            comp: 'Directing people',
            wdd: 'To consistently deliver on time requires a team that\n' +
                'knows what they have to do and when they have to have to\n' +
                'do it. Empowering that team to deliver and then monitoring\n' +
                'progress ensures that the work is done through others, but\n' +
                'there are no surprises. There will inevitably be a time that\n' +
                'critical tasks are not done on time, at times like that quick\n' +
                'and decisive action is needed to confront non-performance.\n' +
                'Constant time pressure also means continuous high levels\n' +
                'of energy and determination in the face of adversity.',
            progressMeasures: [
              {
                id: 'pm-2-0',
                pm: 'People are able to follow my instructions',
                pmMap: 'Provide clear instructions that people are able to follow'
              },
              {
                id: 'pm-2-1',
                pm: 'People rarely misunderstand what I want or need from them',
                pmMap: 'Clearly make people  understand what I want or need from them'
              },
              {
                id: 'pm-2-2',
                pm: 'When I give instructions, I ask questions to ensure they have been understood',
                pmMap: 'Ask questions to ensure they have been understood when I give instructions to others'
              },
              {
                id: 'pm-2-3',
                pm: 'I am comfortable stepping in to provide direction',
                pmMap: 'Feel comfortable stepping in and provide direction'
              },
              {
                id: 'pm-2-4',
                pm: 'I do not wait until people are struggling before I provide direction',
                pmMap: 'Not wait until people are struggling before I provide direction'
              }
            ],
            developmentActions: [
              {
                id: 'pm-2:1-a',
                da: ' Try to motivate people while instructing them. Give direction enthusiastically and point out the advantage of doing things a certain way.'
              },
              {
                id: 'pm-2:1-b',
                da: ' Be as inclusive as possible when providing direction, especially when resistant individuals are involved. Welcome their suggestions and let them know their feedback is valuable.'
              },
              {
                id: 'pm-2:1-c',
                da: ' Watch your tone of voice and mannerisms to ensure you do not seem bossy. This is particularly important if you are uncomfortable or tense. A person under stress often sends the wrong message inadvertently.'
              },
              {
                id: 'pm-2:1-d',
                da: ' By their very nature, some people are intimidating. If you have to provide them with direction, get to know them on an individual level. It will help you to make a connection with them and is likely to dispel some of your preconceived ideas.'
              },
              {
                id: 'pm-2:1-e',
                da: ' If people get defensive while getting instructions, remain composed and do not take things personally. The goal is to get them to move forward in a productive manner and with an appropriate mindset. Try to find out what makes them defensive by talking privately to each person. Ignoring their attitude will not make it go away, and it will become increasingly difficult for you to provide direction without meeting resistance. Show people that you care about the fact that something is bothering them.'
              },
              {
                id: 'pm-2:2-a',
                da: ' Schedule time to check in with each individual periodically, even if not for assistance.'
              },
              {
                id: 'pm-2:2-b',
                da: ' Never assume everyone works well independently. Some people simply require more direction than others, and when they get it they perform well.'
              },
              {
                id: 'pm-2:2-c',
                da: ' Get to know your team. People have different styles and needs, and the more you get to know them the better you will understand their position.'
              },
              {
                id: 'pm-2:2-d',
                da: ' Be realistic about those you supervise. Take into account not only personalities but people\'s experience, skills and level of maturity. For example, someone new to a position is likely to require more direction than a seasoned employee.'
              },
              {
                id: 'pm-2:2-e',
                da: ' Pair more experienced individuals with new employees to maximize the amount of direction they get.'
              },
              {
                id: 'pm-2:2-f',
                da: ' Take advantage of assessment instruments such as 360° feedback or the Birkman personality assessment for a better understanding of the people you work with or manage.'
              },
              {
                id: 'pm-2:2-g',
                da: ' Be accessible. When people ask for assistance, ensure you give them the appropriate time and are patient with their questions.'
              },
              {
                id: 'pm-2:3-a',
                da: ' First delegate those items that need the least instruction and support from you. Rate the tasks according to a scale from least to most direction required on your part and clear them first.'
              },
              {
                id: 'pm-2:3-b',
                da: ' Avoid spending time on repeating instructions. Confirm that your instructions have been understood & ask the person to summarize what they have to do.'
              },
              {
                id: 'pm-2:3-c',
                da: ' Create written instructions, where appropriate, which can be used as reference by colleagues in doubt before asking you. It will allow you to focus your time on addressing specific queries.'
              },
              {
                id: 'pm-2:3-d',
                da: ' Provide direction and preserve time simultaneously, for example, let a subordinate shadow you and give instructions to others as you perform the task.'
              },
              {
                id: 'pm-2:3-e',
                da: ' Be prepared for questions and feedback and do not become defensive or abrupt. People will refrain from asking questions that could clarify confusion.'
              },
              {
                id: 'pm-2:3-f',
                da: ' Include directing others as one of your performance measures. It will help you to prioritize time to do it.'
              },
              {
                id: 'pm-2:4-a',
                da: ' Never assume your directions are perfectly clear. Ask whether people have understood you. Get feedback about the quality of your instructions.'
              },
              {id: 'pm-2:4-b', da: ' Ensure you highlight and emphasize key points.'},
              {
                id: 'pm-2:4-c',
                da: ' Adapt your style of direction to the individual or audience. \'One size fits all\' is not an appropriate approach. Consider people\'s work styles, level of experience and skills. People grasp concepts differently, so consider how you explain them. A discussion may be best for an eloquent person, but a spreadsheet may work better for someone methodical. An experienced engineer, for example, may only have to understand the overall objective, while a new hireling would need detailed instructions. Also, consider people\'s competencies. Some people are more comfortable with ambiguity or more resourceful than others and require less direction.'
              },
              {
                id: 'pm-2:4-d',
                da: ' Communicate the big plan - lay it out. Map a project plan with tasks and deadlines to provide direction for the team. It allows you to frame discussions about progress and you can direct colleagues in a structured way.'
              },
              {
                id: 'pm-2:4-e',
                da: ' Understand the problem or task and its objectives. Take time to organize your thoughts and instructions.'
              },
              {
                id: 'pm-2:4-f',
                da: ' Ensure you stick to the point and do not digress. Too much information and many tangents will confuse people and muddle the waters.'
              },
              {
                id: 'pm-2:4-g',
                da: ' Check where your attention goes. If you are preoccupied with multiple things at once, the direction you are providing may be compromised. Repeat what the person has asked you. Turn off your cellphone and use a private space, if possible, to minimize distractions. You must be focused to give relevant, meaningful instructions.'
              },
              {
                id: 'pm-2:4-h',
                da: ' Communicate instructions both verbally and in writing. Hard-copy instructions ensure people know what you want and limit neglected items. If possible, write your instructions to people in an e-mail or memo, or ask them to take notes.'
              },
            ]
          }
        ]
      },
      'en': {
        characteristic: 'Specialist Performance Template',
        wdd: "Evaluate performance of a specialist on providing clear objectives and instructions to others; interacting with others confidently; communicating in a tactful, non-confrontational and polite manner; reaching win-win outcomes even when there are conflicting interests and limited resources; knowing how to manage the politics of relationships.",
        icon: require('@/assets/Iconography/Characteristics/06_Effective Negotiator.svg'),
        competencies: [
          {
            id: 'en-0',
            icon: require('@/assets/Iconography/Attributes/06-04_Acting Confidently.svg'),
            comp: 'Acting confidently',
            wdd: 'To be customer focused or market aware requires information\n' +
                'about customers and markets. Data can be a powerful tool\n' +
                'for analysing market forces and customer trends, but social\n' +
                'contacts are critical in order to get qualitative insight and\n' +
                'identify leading indicators of change. This information needs\n' +
                'to be understood in the bigger context of your business, and\n' +
                'new connections should be made as early as possible, which\n' +
                'requires keeping an open-mind.',
            progressMeasures: [
              {
                id: 'en-0-0',
                pm: 'I am comfortable expressing myself in front of others',
                pmMap: 'Comfortably express myself in front of others'
              },
              {
                id: 'en-0-1',
                pm: 'I believe I am competent in what I do',
                pmMap: 'Competent in work'
              },
              {
                id: 'en-0-2',
                pm: 'Mostly, I have a “can do” attitude',
                pmMap: 'Have a “can do” attitude'
              },
              {
                id: 'en-0-3',
                pm: 'I am not embarrassed easily',
                pmMap: 'Not become embarrassed easily'
              }
            ],
            developmentActions: [
              {
                id: 'en-0:1-a',
                da: ' Others may know more than you in some areas, but every person brings both strengths and weaknesses to their jobs. Promote your strengths by identifying the parts of a project to which you can add most value. If you are a good problem solver, for example, but are not familiar with the subject, you can still help the team to organize their ideas logically and add value by asking questions from an outsider\'s perspective. Which strengths do you add, regardless of your assignment?'
              },
              {
                id: 'en-0:1-b',
                da: ' Roll up your sleeves and jump in. Nothing will give you more confidence than mastering what you did not know. Become involved in projects and assignments that will help you to gain knowledge in the areas in which you are least confident. Many companies have rotation opportunities for employees to work in different areas of the organization. Ask for assignments that are different from what you have mastered.'
              },
              {
                id: 'en-0:1-c',
                da: ' Engage with people who know more than you or are experts in a particular field. Instead of comparing yourself to them, choose to learn from them.'
              },
              {
                id: 'en-0:1-d',
                da: ' Do not pretend to know what you do not. It is perfectly acceptable that you are not an expert in everything. Defer questions you cannot answer to someone who can, or do your research and get back to the person. People appreciate honesty and will have more respect for you if you do not mislead them.'
              },
              {id: 'en-0:1-e', da: ' Be a student. Accept the role of asking many questions.'},
              {
                id: 'en-0:1-f',
                da: ' Do not give up at the moment things get particularly difficult or confusing. It is part of the learning process and the stage in which most people lose confidence.'
              },
              {
                id: 'en-0:1-g',
                da: ' Ask to be included in meetings and conference calls even when you are not going to participate. The exposure is invaluable in getting comfortable with different settings and building confidence.'
              },
              {
                id: 'en-0:2-a',
                da: ' Positive affirmation can help you to rewire your thinking. Be vigilant about negative thoughts and practice to replace them with positive thinking.'
              },
              {
                id: 'en-0:2-b',
                da: ' Identify someone you admire for their self-confidence and discuss how they view the world. Note the differences in their views and yours.'
              },
              {
                id: 'en-0:2-c',
                da: ' Do not place more importance on mistakes than they deserve. Write down the worstcase scenario. Unless someone\'s life is threatened, the consequences are really not as bad as you think.'
              },
              {
                id: 'en-0:2-d',
                da: ' Read about the many famous people in history who were undeterred by their mistakes and went on to change the world. For example, Thomas Edison experienced 10 000 failures before perfecting the light bulb. It is a good thing that he had the confidence to continue after the first few hundred mistakes!'
              },
              {
                id: 'en-0:2-e',
                da: ' You cannot predict anything100% correctly or control things fully. Make a list of the things over which you do have control versus the things you do not. Make peace with a balance between the two and focus only on the things you can control. For example, do your home work on the topic, rehearse your speech, become familiar with the setting in which you will be presenting it, get to know individuals in the meeting before the big day, and so forth. You have then done your part and the rest is beyond your control.'
              },
              {
                id: 'en-0:2-f',
                da: ' Stop thinking too much about how things will be done and focus on getting started instead. Trust that the process will resolve itself. Choose something you have been putting off and tackle it today.'
              },
              {
                id: 'en-0:2-g',
                da: ' Team up with someone who is action-oriented to help you get started and give you support.'
              },
              {
                id: 'en-0:2-h',
                da: ' Remember that most projects have strict deadlines and always take longer to complete than you expected, so consider that when framing timelines.'
              },
              {
                id: 'en-0:2-i',
                da: ' Prioritize your time. Some things require a great deal of attention and detail and others do not. For example, spending time to perfect an e-mail to a peer is unnecessary, but doing it to examine a contract carefully is time well spent.'
              },
              {
                id: 'en-0:3-a',
                da: ' Exposing yourself to the situations or people that make you fearful is the best way to address your anxiety and gain confidence. The more exposure you have to these situations, the more you will raise your comfort level. Find ways to participate, if only minimally at first, in these kind of settings.'
              },
              {
                id: 'en-0:3-b',
                da: ' Share your anxiety. Find someone who can give you support in times when you are most anxious. For example, if you do not like being in large groups but need to attend a networking function, find a co-worker who enjoys socializing to accompany you.'
              },
              {
                id: 'en-0:3-c',
                da: ' If you are uncomfortable around those with greater authority, make a conscious effort to try to get to know them on a more personal level. It will help to challenge your assumptions about them and see them as individuals instead of authority figures. Talk to individuals while you are waiting for meetings to start; attend social gatherings that allow you to interact in a relaxed manner; gain insight into people by asking others what they think of them.'
              },
              {
                id: 'en-0:3-d',
                da: ' Ask a professional counselor for techniques to relax and reduce anxiety. Breathing exercises, bio-feedback, visualization and hypnosis are just a few of the tools available to you.'
              },
              {
                id: 'en-0:4-a',
                da: ' Positive affirmation can help you to rewire your thinking. Be vigilant about negative thoughts and practice to replace them with positive thinking.'
              },
              {
                id: 'en-0:4-b',
                da: ' Consider how you would react if someone else slipped up in front of you. You would not crucify them. We tend to be hardest on ourselves. When you look around the room, remind yourself that people leave room for mistakes and are more empathetic than you think.'
              },
              {
                id: 'en-0:4-c',
                da: ' Get feedback about how your presentation went or how well your work turned out. Because you are your own worst critic, others can provide a more realistic perspective.'
              },
              {
                id: 'en-0:4-d',
                da: ' Use your sense of humor and practice poking fun at yourself, even in public. It is an easy way to connect with others and take pressure off you. How many times have you looked at situations and found their funny sides in hindsight? Try using that perspective in the present.'
              },
              {id: 'en-0:4-e', da: ' Focus on the issues or problem instead of yourself.'}
            ]
          },
          {
            id: 'en-1',
            icon: require('@/assets/Iconography/Attributes/06-03_Acting Diplomatically.svg'),
            comp: 'Acting diplomatically',
            wdd: 'Ensuring compliance to documented policies and\n' +
                'procedures requires a high level of conscientiousness and\n' +
                'detail orientation.',
            progressMeasures: [
              {
                id: 'en-1-0',
                pm: 'I am able to defuse tense situations',
                pmMap: 'Defuse tense situations'
              },
              {
                id: 'en-1-1',
                pm: 'I relate well to people even if they are different from me',
                pmMap: 'Relate well to people even if they are different from me'
              },
              {
                id: 'en-1-2',
                pm: 'I communicate delicate information in a tactful manner',
                pmMap: 'Communicate delicate information in a tactful manner'
              },
              {
                id: 'en-1-3',
                pm: 'I am able to be honest without being disrespectful',
                pmMap: 'Be honest without being disrespectful'
              }
            ],
            developmentActions: [
              {
                id: 'en-1:1-a',
                da: ' Depersonalize the interaction. Think of yourself as acting in a role, for example, as a manager dealing with staff, a customer service representative dealing with a customer etcetera. You are not being attacked by the other person or people; they are interacting with your role.'
              },
              {
                id: 'en-1:1-b',
                da: ' Think before you speak. Once you have said something, you cannot take it back. People will remember utterances that provoked a strong emotional response. Saying something that offends, humiliates or criticizes will damage a relationship.'
              },
              {
                id: 'en-1:1-c',
                da: ' Manage your emotions. Being aware of your own emotional triggers will help to prevent emotional outbursts that can damage a relationship. Think of it as identifying your \'red buttons\', for example, someone making a racist comment or implying you lack intelligence may provoke a stronger than usual reaction from you.'
              },
              {
                id: 'en-1:1-d',
                da: ' Listen more than you talk. Diplomacy requires an understanding of people, their agendas, belief systems and values. These things can be identified if you listen to what is not being said, too. Most of the time you get important information not just from the message, but from its delivery. Be aware of timing and tone.'
              },
              {
                id: 'en-1:2-a',
                da: ' Consider the reasons why you want to communicate certain information to someone. Is the message critical to the parties involved, or are you satisfying a personal and emotional need by sharing it?'
              },
              {
                id: 'en-1:2-b',
                da: ' Good timing is essential. You may be more successful in sharing your thoughts later, so be patient and hold off if you believe people will be more receptive at a later stage.'
              },
              {
                id: 'en-1:2-c',
                da: ' Put yourself in the other person\'s shoes. There are probably some things about which you are sensitive that would offend you if someone shared them with you. Make the effort to understand the impact of what you have to say on the person. Weigh whether it is important enough to say at all. If it is, how would you have liked to hear it?'
              },
              {
                id: 'en-1:2-d',
                da: ' Remain composed throughout. It puts you in a better position to handle conflict or tense situations. Do not take things personally. In tense circumstances, you can expect emotions to run high and people will be more prone to launching unfair attacks. If you are feeling too emotional, refrain from responding and take time to collect your thoughts. You can ask for time to think things through, if necessary. Keep your tone of voice consistent and calm, because raising it will only encourage others to do the same.'
              },
              {
                id: 'en-1:2-e',
                da: ' Get a good reading on your audience and adjust your strategy accordingly. Invariably, some people will need more delicate handling than others.'
              },
              {
                id: 'en-1:3-a',
                da: ' It is difficult to establish a mutually respectful relationship if you do not genuinely listen to what people have to say. Whether you agree or not, acknowledge the other person\'s point of view. Focus on being attentive instead of telling people \'the way it is\'.'
              },
              {
                id: 'en-1:3-b',
                da: ' Ask people\'s opinions and do not make quick judgments or speak dismissively, indicating you already have all the answers.'
              },
              {
                id: 'en-1:3-c',
                da: ' Guard against aggressive body language or behaviors that others could perceive as overly authoritarian or arrogant, for example, raising your voice, interrupting people or cutting them off, crossing your arms in front of your body, or tapping your foot impatiently.'
              },
              {
                id: 'en-1:4-a',
                da: ' Guard against hidden biases. You may be quite diplomatic with most people, except those from a particular group. Consider taking the implicit association test which is available at www.understandingprejudice.org/iat/. It will help to identify subconscious biases.'
              },
              {
                id: 'en-1:4-b',
                da: ' If you struggle to understand another person\'s perspective, focus on your commonalities. They tend to be universal, for example, an appreciation of good service, desire to advance a career, recognition of the importance of quality family time anything that binds you and the person together.'
              },
              {
                id: 'en-1:4-c',
                da: ' Read biographies or watch documentaries about great politicians. Note how they interact with different interest groups, get their message across or state their opinion without offending or alienating people who hold different views.'
              },
            ]
          },
          {
            id: 'en-2',
            icon: require('@/assets/Iconography/Attributes/06-02_Managing Negotiations.svg'),
            comp: 'Managing negotiations',
            wdd: 'Managing innovation in a team doesn\'t necessarily require you\n' +
                'to come up with the ideas, but it is important to have an open\n' +
                'mind to what is different. Innovation should focus on fixing a\n' +
                'particular problem in a new way that makes things easier,\n' +
                'faster, cheaper or better. Deciding on which ideas to invest in\n' +
                'and test means having a good sense of judgment which\n' +
                'combines analysis and intuition.',
            progressMeasures: [
              {
                id: 'en-2-0',
                pm: 'I can reach a compromise when negotiating',
                pmMap: 'Reach a compromise when negotiating'
              },
              {
                id: 'en-2-1',
                pm: 'I usually arrive at outcomes that benefit both parties',
                pmMap: 'Arrive at outcomes that benefit both parties'
              },
              {
                id: 'en-2-2',
                pm: 'When the negotiation is over, both parties usually feel positive',
                pmMap: 'Ensure both parties usually feel positive when the negotiation is over'
              },
              {
                id: 'en-2-3',
                pm: 'It does not bother me to ask for what I want',
                pmMap: 'Ask for what I want'
              }
            ],
            developmentActions: [
              {
                id: 'en-2:1-a',
                da: ' Work on your style and approach: stay composed, do not raise your voice, restate what the other person has said and acknowledge their point of view. Such an approach is critical to maintain a productive discussion - loud displays or outbursts will always work to your disadvantage.'
              },
              {
                id: 'en-2:1-b',
                da: ' If talking about people\'s emotions is important to clear the air, do so but manage the conversation carefully. The goal is to address feelings but get to the business of discussing facts as quickly as possible.'
              },
              {
                id: 'en-2:1-c',
                da: ' Allow the other party to vent their frustrations so that they feel they have been heard. It will probably reduce volatility during the discussions.'
              },
              {
                id: 'en-2:1-d',
                da: ' If discussions between you and another person heat up, speak to them as if they are not upset, regardless of their reaction. Focus on your response, not their reaction.'
              },
              {
                id: 'en-2:1-e',
                da: ' Try to be empathetic when a situation is emotionally charged. Why does the other party feel so strongly about a position?'
              },
              {
                id: 'en-2:1-f',
                da: ' Be quiet at the right moments. When people become anxious, it is a natural human reaction to try to fill the silence with meaningless noise, especially during conflict. During negotiations, anxious people tend to say things that erode their positions. Bide your time by asking questions.'
              },
              {
                id: 'en-2:1-g',
                da: ' Are you giving away your emotions inadvertently - do you roll your eyes, look away impatiently, fidget? Be conscious of the signals you send.'
              },
              {
                id: 'en-2:1-h',
                da: ' Do not get pulled in by others\' threats, blame or games. Remember, these tactics can rattle you, so do not let them.'
              },
              {
                id: 'en-2:2-a',
                da: ' Only consider a win-lose negotiation if you do not need an ongoing relationship with the other party. A party that gains no benefits from a negotiation will be reluctant to maintain a relationship with you.'
              },
              {
                id: 'en-2:2-b',
                da: ' Consider honesty and openness before manipulation and let common principles of ethics and fairness guide you when negotiating.'
              },
              {
                id: 'en-2:2-c',
                da: ' Avoid coming to the table with inflexible black-or-white positions. There is always room to consider other options if you really listen to what the other side has to say.'
              },
              {
                id: 'en-2:2-d',
                da: ' Refrain from using threats to get your way. Threats are unproductive and only serve to put the other party on the defensive.'
              },
              {
                id: 'en-2:2-e',
                da: ' Before negotiating, think carefully about the points you could concede and keep those for leverage. Even if you have the advantage, conceding to some points establishes goodwill and allows the other party to walk away with some sense of gain.'
              },
              {
                id: 'en-2:3-a',
                da: ' Start negotiations by establishing an environment of cooperation. Allow people to have a short period to mingle informally and engage in small talk, arrange the seating to not differentiate sides, have breaks and encourage people to talk among themselves.'
              },
              {id: 'en-2:3-b', da: ' Allow parties to verbalize their goals for the meeting.'},
              {
                id: 'en-2:3-c',
                da: ' Always listen to the issues and underlying interests of the parties involved and try to understand them. It is surprising how many negotiations fail due to the issues being misunderstood. Ask as many questions as possible to clarify people\'s motives and key concerns.'
              },
              {
                id: 'en-2:3-d',
                da: ' Take steps to ensure that all parties actually hear each other. Rephrase what a person says during a discussion if there is any doubt. Summarize the major points made as the conversation progresses.'
              },
              {
                id: 'en-2:3-e',
                da: ' Use language that clearly indicates your willingness to solve a problem in a mutually beneficial way and work together. Use sentences such as \'What if we try this?\' or \'What do you think about the two of us taking this approach?\''
              },
              {
                id: 'en-2:3-f',
                da: ' Use non-verbal communication to let the other party know you are listening and open to discussion - maintain eye contact and nod when you understand. Avoid a posture that says you feel defensive or threatened, such as crossing your arms, scowling, shaking your head or leaning back in your chair as if you have disengaged.'
              },
              {
                id: 'en-2:3-g',
                da: ' Think about the other party\'s personal style. Do they tend to be diplomatic, or are they more frank and lay everything on the table upfront? Adapt accordingly as you negotiate.'
              },
              {
                id: 'en-2:3-h',
                da: ' Consider the negotiation points that are of little value to you and highly valued by the other party. If you have to give in, it is important to know what these points are in advance.'
              },
              {
                id: 'en-2:3-i',
                da: ' Make any progress and agreement as visible as possible. Document success throughout the discussions by writing the agreed-upon points on a flipchart or board. When frustration is high, refer to the progress that has been made.'
              },
              {
                id: 'en-2:3-j',
                da: ' Utilize comparable or precedent-setting transactions as a benchmark for negotiations. The information can help you to gauge the type of outcome you might expect and understand the points to which the other party will likely be willing to agree.'
              },
              {
                id: 'en-2:4-a',
                da: ' Consider all your interests before negotiations begin. You may have to concede some points, but be clear about the ones you absolutely cannot concede. If you cannot negotiate a win-win solution, what is the least acceptable scenario? Knowing that will help you to stick to your guns.'
              },
              {
                id: 'en-2:4-b',
                da: ' If the other party has adopted the role of tough negotiator, find ways during the process to commend them on their toughness and recognize that they drive a hard bargain.'
              },
              {
                id: 'en-2:4-c',
                da: ' If you cannot agree on everything, work on the points that are critical and focus on them for now. Agree to address the other points later, but try to set a precedent for a successful negotiation experience.'
              },
              {
                id: 'en-2:4-d',
                da: ' If you have reached a stalemate, consider engaging an arbitrator acceptable to both parties instead of conceding.'
              },
              {
                id: 'en-2:4-e',
                da: ' Be prepared to walk away rather than give in. This may not be the best time to negotiate and there may be another way to get what you need. Walking away when you do not stand to gain anything is perfectly acceptable.'
              },
              {
                id: 'en-2:5-a',
                da: ' Consider the negotiation\'s goals. What do you want from it? What do you think the other person wants?'
              },
              {
                id: 'en-2:5-b',
                da: ' Consider possible solutions and alternatives. If you do not reach an agreement with the other party, what are your alternatives? Are they good or bad? How much does it matter if you cannot agree? Does failure to reach an agreement eliminate future opportunities? Which alternatives could the other person have?'
              },
              {
                id: 'en-2:5-c',
                da: ' Consider relationships. What is a relationship\'s history; could or should it have an impact on the negotiation? Are there any hidden issues that could influence the negotiation and how will you handle these?'
              },
              {
                id: 'en-2:5-d',
                da: ' Consider the consequences of you winning or losing this negotiation. and what they mean to the other person.'
              },
              {
                id: 'en-2:5-e',
                da: ' Who holds what kind of power in the relationship? Who controls resources? Who stands to lose the most if agreement is not forthcoming? What power does the other person have to satisfy your needs?'
              },
              {
                id: 'en-2:5-f',
                da: ' Never make a false statement or assertion, and collect as much accurate information as possible before any negotiations.'
              },

            ]
          },
          {
            id: 'en-3',
            icon: require('@/assets/Iconography/Attributes/06-01_Being Politically Astute.svg'),
            comp: 'Being politically astute',
            wdd: 'There is a natural tension between functions in a business\n' +
                'which often results in a conflict of interests and competition\n' +
                'for resources. The ability to manage this conflict constructively\n' +
                'and reach win-win agreements is a critical part of building a\n' +
                'strong business.',
            progressMeasures: [
              {
                id: 'en-3-0',
                pm: 'I adapt my approach based on a particular situation or person',
                pmMap: 'Adapt my approach based on a particular situation or person'
              },
              {
                id: 'en-3-1',
                pm: 'I understand how personal power dynamics influence people and the decisions they make',
                pmMap: 'Understand how personal power dynamics influence people and the decisions they make'
              },
              {
                id: 'en-3-2',
                pm: 'I seldom, or never, get others in trouble because of what I say',
                pmMap: 'Seldom, or never, get others in trouble because of what I say'
              },
              {
                id: 'en-3-3',
                pm: 'I know which information to share with whom',
                pmMap: 'Know which information to share with whom'
              }
            ],
            developmentActions: [
              {
                id: 'en-3:1-a',
                da: ' Observe what enables a respected leader in your organization to use politics to push an agenda. It can help to dispel a stereotype you may hold about the nature of politicking.'
              },
              {
                id: 'en-3:1-b',
                da: ' Read about politically astute leaders, such as Mahatma Gandhi and Nelson Mandela, who are widely respected and overcame tremendous obstacles by somehow managing the politics of their time. It will provide a different perspective of politics.'
              },
              {
                id: 'en-3:1-c',
                da: ' Remain genuine and sincere. If your actions are guided by what is best for the organization, rather than what is best for you, you will feel more comfortable.'
              },
              {
                id: 'en-3:1-d',
                da: ' Make clear to yourself why it is necessary to use politics in the goal you are trying to achieve. Compile a list of ways the \'right\' people can help you to accomplish your goal more effectively. Does it make sense to do it on your own? Do you believe in your position enough to defend it? On which ethics or values do you really have to infringe to achieve your goal?'
              },
              {
                id: 'en-3:1-e',
                da: ' Sometimes, as skeptics, we dehumanize people with political power. Attend organizational events that give you an opportunity to talk to key decision makers on a more personal level. Find your common interests, passions and humanity. You will find many respectable, honest people just like you.'
              },
              {
                id: 'en-3:2-a',
                da: ' Find a trusted peer or mentor in your organization with whom you can discuss the internal politics. Learn to understand who holds the power to make decisions in different areas, both in theory and reality.'
              },
              {
                id: 'en-3:2-b',
                da: ' Become familiar with the company\'s organizational chart and its critical positions. Make it a goal to introduce yourself at least once to everyone in key positions.'
              },
              {
                id: 'en-3:2-c',
                da: ' Maximize your networking opportunities. Attend receptions, company events and conferences to establish relationships with as many people as possible, not just in your company but also in your field.'
              },
              {
                id: 'en-3:2-d',
                da: ' Be prepared to succinctly communicate the way your work, project or idea can make a difference. You do not often have the opportunity to discuss your ideas at length, so a well-communicated and convincing speech is important.'
              },
              {
                id: 'en-3:2-e',
                da: ' Make allies of the relevant people. Keep them informed of the obstacles you encounter, including resistance from people or departments. Together you can develop a strategy to overcome these hurdles and share the task of influencing others.'
              },
              {
                id: 'en-3:2-f',
                da: ' Try to develop coalitions for maximum influence. Power often lies in numbers and some issues need a coalition to push an agenda.'
              },
              {
                id: 'en-3:2-g',
                da: ' Are there specific groups with which you have trouble politically, all or most of the time? Look for particular biases you may harbor. You may think they are invisible, but people quickly pick up subtleties in behavior or language that makes them defensive and resistant to your influence.'
              },
              {
                id: 'en-3:2-h',
                da: ' Timing can make all the difference in garnering support. Sometimes it simply is not the right time to keep pushing. Be sensitive about times you may need to back off in order to keep the door open for later. List the conditions that make this an inappropriate time to introduce your agenda.'
              },
              {
                id: 'en-3:2-i',
                da: ' Often, it is not that you have reached the wrong people, but your delivery has not been well received. Poor communication or interpersonal skills are a surefire way to lose influence. A 360Â° assessment is effective for feedback on your strengths and weaknesses, as well as issues on which you can work with a coach.'
              },
              {
                id: 'en-3:2-j',
                da: ' Read about ordinary people such as Erin Brockovich who, with little political experience, was able to navigate through complex politics and exert great influence.'
              },
              {id: 'en-3:3-a', da: ' Forward e-mails of praise from clients or other team members to relevant people.'},
              {
                id: 'en-3:3-b',
                da: ' Keep a list of major accomplishments for your reference during performance reviews. The person doing your evaluation may not remember all your achievements throughout the year.'
              },
              {
                id: 'en-3:3-c',
                da: ' Ask experts and respected colleagues their professional opinions and advice on a project. It gives you an opportunity to meet influential people and make your work visible.'
              },
              {
                id: 'en-3:3-d',
                da: ' Become involved in projects beyond your immediate scope that expose you to decision makers. For example, volunteer for a taskforce or committee.'
              },
              {
                id: 'en-3:3-e',
                da: ' If, at first, you are uncomfortable to promote your talents, talk about your team\'s accomplishments. It will highlight your achievements indirectly.'
              },
              {
                id: 'en-3:3-f',
                da: ' Invite key decision makers from other divisions or groups to add value to your meetings and become familiar with your projects.'
              },
              {
                id: 'en-3:3-g',
                da: ' Your accomplishments may speak for themselves at present, but a former leader in your organization may not have had the same experience with you. Do not overlook previous relationships that may require extra attention or even repair.'
              }
            ]
          }
        ]
      }
    },
  },
  selectedCharacteristic: {
    sc1: "Select the profile you want to evaluate",
    sc2: "Select one to continue",
    sc3: "Next",
    sc4: "Search Skill"
  },
  searchCompetency: {
    sc1: "Search for the performance dimension you want to measure",
    sc2: "Select one to continue"
  },
  selectCompetency: {
    sc1: "Select the performance measure you want to achieve next",
    sc2: "Select one to continue"
  },
  rateYourLevel: {
    ryl1: "How would you rate your level of performance for this dimension?",
    ryl2: "Knowing where your starting point is a step forward to your goal!",
    ryl3: "SLIDE TO YOUR LEVEL",
    ryl4: "VERY LOW",
    ryl5: "AVERAGE",
    ryl6: "GOOD",
    ryl7: "VERY GOOD",
    ryl8: "EXCELLENT"
  },
  trainingDuration: {
    td1: "How long is this performance cycle?",
    td2: "When will a performance score be assigned!",
    td3: "1 Month",
    td4: "3 Months",
    td5: "6 Months",
    td6: "12 Months",
    td7: "Custom Time"
  },
  progressMeasure: {
    pm1: "Choose performance measure",
    pm2: "Choose performance dimension that can measure your progress",
    pm3: "Custom performance measure (Optional)",
    pm4: "Add your own performance measure",
    pm5: "Add custom performance measure",
    pm6: "Submit",
    pm7: "Enter the performance measure",
    pm8: "performance Measure",
    pm9: "Cancel"
  },
  reviewSkill: {
    rs1: "Alright, review the summary of your new evaluation",
    rs2: "Main Skill",
    rs3: "Select how would you rate your level",
    rs4: "Your next performance review will be due in ",
    rs5: "Performance Cycle Duration",
    rs6: "Performance Measure Progress"
  },
  mySkills: {
    ms1: "Performance History",
    ms2: "You haven't done any performance review yet",
    ms3: "When you add reviews, they will appear here",
    ms4: "Add New Skill",
    ms5: "In Progress",
    ms6: "Completed"
  },
  skillDetails: {
    h1: "The Player hasn't added any skills yet",
    p1: "When Player adds skills, they will appear here",
    sd1: "Motivation",
    sd2: "Action",
    sd3: "Feedback",
    details: {
      d0: "Skill Details",
      d1: "Initial Level",
      d2: "Duration",
      d3: "Training Duration",
      d4: "Progress Measures",
      d5: "Update Training Duration"
    },
    progress: {
      p1: "No Motivation Logs Yet",
      p2: "When you add motivation logs on this skill they will appear here",
      p3: "Assess your Motivation",
      p4: "Your Latest Motivation Log",
      p5: "Your Previous Log",
      p6: "Created Date"
    },
    action: {
      a1: "Add a Custom Development Action",
      a2: "Submit",
      a3: "Enter the Development Action",
      a4: "Development Action",
      a5: "Add Custom Development Action",
      a6: "Cancel",
      a7:"Select from a list of suggested development actions",
      a8:"Completed Development Actions"
    }, action1: {
      a1: "\n" +
          "Send Feedback Invite",
      a2: "This action will send a feedback request to the selected invitees on ",
      a3: "Submit",
      a4: "Cancel",
      a5: " asking to rate you on selected skill progress.",

    },
    action2: {
      a1: "\n" +
          "\n" +
          "Email Schedules for ",
      a3: "Cancel Email",
      a4: "Reschedule Email",
      a5: "Are you sure that you want to cancel the emails schedule for",
      a6: "Are you sure that you want to reschedule the emails for ",
      a7: "ok",
      a8: "Sent",
      a9: "Followup",
      a10: "Feedback Received",
      a11: "Gap Closed",
      a12: "Scheduled",
      a13: "Canceled",
      a15: "Congrats on completing your skill",
      a16: "Note that by marking this skill closed you will not be able to work on these development actions anymore. Your scheduled email feedbacks will be cancelled and no advisor will be able to give you further feedback. If you are not sure about this action, cancel the popup and consult your coach about it.",
      a17: " I am sure I did a good job, let’s close my goal ",
      a18: "No Initial Gap Rated",
      a19: "Confirmation for No Gap ",
      a20: "This action will mark a NO GAP to the requester. This will indicate no further need to develop the skill, hence no further email will be sent to you for evaluating skill progress.\n" +
          "        ",
      a21: "Cancel",
      a22: "Expire ",
      a23: "Expired",
      a24: "Are you sure that you want to cancel the email ",
      a25: "Cancel Single Email",
      a26: "Expire Single Email",
      a27: "Are you sure that you want to expire the email ",
      a28: "Skill Marked As Complete",
      a29: "You can’t cancel this schedule since the email has been already sent to the advisor, you can cancel the schedule once the advisor completes this pending rating or advise them to ignore the email and no other ratings will be send. ",
      a30: 'Benchmark'
    },
    endorsement: {
      e1: "Goal Completed",
      e2: "Congratulations on successfully completing your goal!!",
      e3: "Add Another Skill",
      e4: "No Invitees Yet",
      e5: "When you invite others to give you feedback on your progress they will be listed here",
      e6: "Send Invites",
      e7: "Mark Goal Complete"
    }
  },
  components: {
    progressMeasureChart: {
      pmc1: "Relevancy",
      pmc2: "Progress",
      pmc3: "Practice"
    },
    progressMeasureHorizontal: {
      pmh1: "Relevancy",
      pmh2: "Progress",
      pmh3: "Practice"
    },
    threeSwitchToggle: {
      tst1: "    ",
      tst2: "DOING",
      tst3: "DONE"
    }
  },
  competencyProgress: {
    cp1: "Your motivation survey for the developing the behaviour: ",
    cp2: "Going Great",
    cp3: "Not So Good",
    cp4: "Next",
    cp5: "Submit",
    cp6: "Do you still feel this is the right goal to be acheived now?",
    cp7: "Do you feel you are making progress towards your goal?",
    cp8: "Are you getting an opportunity to practice and apply the learning?",
    cp9: " is due for more than ",
    cp10:" days.",

    cp11:" Please take a minute to suggest how your skill development is going.",
    cp12:"Your Motivation Survey is Complete.",

    threeStepToggle: {
      tst1: "YES",
      tst2: "PARTLY",
      tst3: "NO"
    },
    result : {
      r1: "Your progress has been successfully submitted",
      r2: "Your next progress will be in a month. See you.",
      r3: "Seek external feedback?",
      r4: "Close"
    }
  },
  endorsementInvite: {
    lbl1: 'Advisor Email',
    lbl2: 'Advisor Name',
    ei1: "Next",
    ei2: "Send Invite",
    invitePeople: {
      ip1: "Invite People",
      ip2: "Enter email address to invite",
      ip3: "Add Email"
    },
    progressMeasure: {
      pm1: "Assign Progress Measures",
      pm2: "Choose the behaviour measure you want to assign to invitees"
    },
    response: {
      r0: "Hi ",
      r1: "I'm working on developing some new abilities  and I'd like you to help me measure my progress. This will only take a minute or so.",
      r2: "On the next screen you’ll be asked one question for each behavior:",
      r3: "You'll compare where I am today with where you believe I could be with focus, practice and support.",
      r4: "I will not be able to see your numercial ratings on my performance or potential. I will only see the progress you think I am making in closing the gap over time, so please be completely candid about these ratings.",
      r5: "Hi,",
      r6: "With the following feedback, I will be able to see if my current gap is getting wider or getting closed.",
      r7: "I will be able to see if the gap is getting bigger, smaller or staying the same relative to your first rating.",
      r8: "It only take a few seconds to update the answer you provide each time.",
      r9: "In your view, how big is the gap now between: how well I do this (Perform), and how well you think I could do it (Potential)?",
      r10: "The light green dot is your previous response.",
      r11: "In your view, how big is the gap between how well ",
      r12: "SLIDE TO RATE",
      r13: "Thank you for submitting your feedback. As my advisor, I will reach you periodically for advice. If you choose to stop the process, just ignore the email and any further schedules will be stopped. Thank you for your support with my skill development.",
      r14: "Start",
      r15: "Next",
      r16: "Submit Feedback",
      r17: "NO GAP",
      r18: "SMALL GAP",
      r19: "MODERATE GAP",
      r20: "LARGE GAP",
      r21: "SIGNIFICANT GAP",
      r22:"does this now, and how well you think they could do it?",
      r23:"Previous Rating"
    }
  },
  profile: {
    p1: "Username",
    p2: "Name",
    p3: "Email",
    p4: "Status",
    p5: "Company",
    p6: "Edit",
    p7: "Birth Date",
    p8: "Mobile",
    p9: "Gender",
    p10: "Address Line 1",
    p11: "Address Line 2",
    p12: "City",
    p13: "State",
    p14: "Country",
    p15: "Twitter",
    p16: "Facebook",
    p17: "Instagram",
    p18: "LinkedIn",
    p19: "Edit Profile",
    p20: "Account",
    p21: "Information",
    p22: "Social",
    p23: "Save Changes",
    p24: "Reset",
    account: {
      a1: "Change Avatar",
      a2: "Change Password",
      a3: "Old Password",
      a4: "New Password",
      a5: "Confirm Password",
      a6: "First Name",
      a7: "Last Name",
      a8: "Active",
      a9: "Blocked",
      a10: "Deactivated",
      a11: "Password Changed",
      a12: "Password was successfully changed",
      a13: "Password Change Failed",
      a14: "Password could not be changed"
    }
  },
  coach: {
    coachingExperience: {
      ce1: "ID",
      ce2: "Name",
      ce3: "Email",
      ce4: "Coaching Experience",
      ce5: "Cancel"
    },
    coachingExperienceChart: {
      cec1: "Relationship",
      cec2: "Resource Availability",
      cec3: "Network Support"
    },
    coachingExperienceData: {
      ced1: "No Coaching Logs Yet",
      ced2: "When the Player adds coaching logs, they will appear here",
      ced3: "Latest Stats",
      ced4: "Previous Stats"
    },
    traineeList: {
      tl1: "ID",
      tl2: "Name",
      tl3: "Email",
      tl4: "Competencies",
      tl5: "Progress",
      tl6: "View",
      tl7:"Plan"
    }
  },
  tblHeadings: {
    th1: "ID",
    th2: "NAME",
    th3: "EMAIL",
    th4: "ADVISOR NAME",
    th5: "COMPETENCIES",
    th6: "COACHING EXPERIENCE",
    th7: "ONBOARDING",
    th8: "MONITORING",
    th9: "EXPERIENCE",
    th10: "ACTION",
    th11: "ACTIONS",
    th12: "COMPANY",
    th13: "USER TYPE",
    th14: "STATUS",
    th15: "COMPANY NAME",
    th16: "COACHING",
    th17: "MOTIVATION",
    th18: "PLAYER",
    th19: "COACH",
    th20: "COMPETENCY NAME",
    th21: "FEEDBACK",
    th22: "PROGRESS"
  },
  msg:{
    msg1:{
      suc_title: "Account Updated",
      suc_desc: "Account details successfully updated",
      err_title: "Account Update Failed",
      err_desc: "Account details could not be updated"
    },
    msg2:{
      suc_title: "Information Updated",
      suc_desc: "Information was successfully updated",
      err_title: "Information Update Failed",
      err_desc: "Information could not be updated"
    },
    msg3:{
      suc_title: "Social Details Updated",
      suc_desc: "Social Details successfully updated",
      err_title: "Social Details Update Failed",
      err_desc: "Social Details could not be updated"
    }
  },
  notes:{
    title: 'Notes',
    msg_prefix: 'From',
    lbl0 : 'Add Note',
    lbl1 : 'Type',
    lbl3:'Start Time',
    lbl4:'Time Zone',
    lbl1_opt0 : 'Note',
    lbl1_opt1 : 'Kudos',
    lbl1_opt2 : 'Alert',
    lbl1_opt3 : 'Message',
    lbl1_opt4 : 'Meeting',
    lbl2 : 'Meeting Date',
  },
  todo:{
    title : 'Todo',
    h1: 'My Development Actions',
    opt0: 'All Tasks',
    lbl0: 'Filters',
    lbl0_opt0 : 'Doing',
    lbl0_opt1 : 'Done',
    lbl0_opt2 : 'Trashed',
    lbl1 : 'Labels',
    lbl1_opt0 : 'Attribute',
    lbl1_opt1 : 'Skill',
    lbl2 : 'search'
  },
  changelog:{
    title:'Changelog',
    lbl0_opt0:'All entries',
    lbl0_opt1:'New',
    lbl0_opt2:'Improved',
    lbl0_opt3:'Fixed'
  }
}
